<template>
  <Vueform name="mainvueform" v-model="formCommon.formPage" size="sm" ref="vueform$">
    <template #empty>
      <FormSteps ref="formSteps$" @previous="expandAll" @finish="createPageFour" name="allStep">

        <FormStep ref="page0$" name="page0" :elements="[
          'containerThongTin',
          'containerThongTinHanhChinh',
          'divider_thongtinhanhchinh',
          'containerTongTrang',
          'divider_tongtrang',
          'containerTienSuBenh',
          'divider_tiensubenh',
          'containerTienSuBenhXaHoi',
        ]" label="THÔNG TIN" :labels="{
          next: 'Tiếp theo',
          previous: 'Quay lại'
        }" @complete="createPageOne" />
        <!-- @complete="createPageOne" -->
        <FormStep ref="page1$" name="page1" :elements="[
          'containerThongTin',
          'containerTinhThan',
          'divider_tinhthan',
          'containerVanDong',
          'divider_vandong',
          'containerDinhDuong',
        ]" label="HOẠT ĐỘNG & DINH DƯỠNG" :labels="{
          next: 'Tiếp theo',
          previous: 'Quay lại'
        }" @complete="createPageTwo" />
        <!-- @complete="createPageTwo" -->

        <!-- <FormStep
          name="page2"
          :elements="['containerThongTin', 'containerDinhDuong']"
          label="DINH DƯỠNG"
        /> -->
        <FormStep ref="page2$" name="page2" :elements="[
          'containerThongTin',
          'divide-Chamsocbanchan',
          'containerBanChan',
          'divide-SuDungThuoc',
          'containerSuDungThuoc',
          'containerDuongHuyet',
          'divide-HocTap',
          'containerHocTap',
        ]" label="KHẢ NĂNG TỰ CHĂM SÓC" :labels="{
          next: 'Tiếp theo',
          previous: 'Quay lại'
        }" @complete="createPageThree" />
        <!-- @complete="createPageThree"  -->

        <FormStep ref="page3$" name="page3" label="ĐỘNG LỰC & MỤC TIÊU" :elements="[
          'containerThongTin',
          'containerDLVMT'
        ]" :labels="{
          next: 'Tiếp theo',
          previous: 'Quay lại',
          finish: 'Hoàn thành'
        }" />
        <!-- @complete="createPageFour" -->
      </FormSteps>

      <FormElements name="vueelement">
        <GroupElement name="containerThongTin">

          <StaticElement name="h1" tag="h3" content="PHIẾU KẾ HOẠCH GIÁO DỤC VÀ HỖ TRỢ TỰ QUẢN LÝ BỆNH ĐTĐ (DSMES PLAN FORM)
" align="center" />

          <TextElement class="labeltext" name="courseName" label="Khóa" :columns="{
            container: 4,
          }" :disabled="isDisabled" />

          <DateElement class="labeltext" name="executionDate" label="Ngày thực hiện" :columns="{
            container: 4,
          }" :disabled="isDisabled" />

          <TextElement class="labeltext" name="executorName" label="Người thực hiện (Họ và tên)" :columns="{
            container: 4,
          }" :disabled="isDisabled" />
          <ButtonElement name="buttonToggle" @click="toggleAll" :columns="{
            container: 1,
          }">
            {{ isExpandedNew ? 'Thu gọn' : 'Mở rộng' }}
          </ButtonElement>
          <!-- <ButtonElement
          name="reset"
          button-label="Làm mới"
          :secondary="true"
          :resets="true" :columns="{
            container: 9,
          }"
          :disabled="isDisabled"
        /> -->
          <ButtonElement name="buttonEdit" @click="editBtn" v-if="isDisabled" :columns="{
            container: 1,
          }">
            Chỉnh sửa
          </ButtonElement>
          <ButtonElement name="buttonSave" @click="updateBtn" v-if="isEdit && !isDisabled" :columns="{
            container: 1,
          }" :condition="[[
            'buttonEdit',
            'empty',]
          ]">
            Lưu lại
          </ButtonElement>
          <ButtonElement align="left" secondary name="buttonCancelAction" @click="cancelBtn"
            v-if="isEdit && !isDisabled" :columns="{
              container: 1,
            }" :condition="[[
            'buttonEdit',
            'empty',]
          ]">
            Hủy
          </ButtonElement>



          <StaticElement name="divider_thongtinchung" tag="hr" />
        </GroupElement>

        <GroupElement name="containerThongTinHanhChinh">
          <StaticElement name="header_thong_tin_hanh_chinh" tag="h4" content="THÔNG TIN HÀNH CHÍNH"
            :columns="{ container: 3 }" />
          <div class="toggle-icon-container">
            <span @click="toggleThongTinHanhChinh">
              <inline-svg :src="isShowThongTinHanhChinh
                ? '/media/svg/icons/Neolex/Basic/circle-minus.svg'
                : '/media/svg/icons/Neolex/Basic/circle-plus.svg'
                " />
            </span>
          </div>
        </GroupElement>

        <!-- transition removed for performance -->
          <GroupElement name="container_16" v-show="isShowThongTinHanhChinh" class="border-group">
            <TextElement name="fullName" label="Họ và tên" :columns="{
              container: 7,
            }" :rules="['required']" :disabled="isDisabled" />
            <TextElement name="yearOfBirth" label="Năm sinh" input-type="number" :columns="{
              container: 3,
            }" :rules="['required']" :disabled="isDisabled" />
            <SelectElement name="gender" :items="genders" :search="true" :native="false" label="Giới tính"
              input-type="search" autocomplete="off" :columns="{
                container: 2,
              }" :rules="['required']" :disabled="isDisabled" />
            <TextElement name="phoneNumber" label="Số điện thoại" :columns="{
              container: 6,
            }" :rules="['required']" :disabled="true" />
            <TextElement name="residence" label="Nơi sống" :columns="{
              container: 3,
            }" :rules="['required']" :disabled="isDisabled" />
            <TextElement name="job" label="Nghề nghiệp" :columns="{
              container: 3,
            }" :rules="['required']" :disabled="isDisabled" />
            <SelectElement name="diseaseType" :items="diseasesOpts" :search="true" :native="false"
              label="Loại Đái tháo đường" input-type="search" autocomplete="off" :columns="{
                container: 6,
              }" :rules="['required']" :disabled="isDisabled" />
            <TextElement name="diagnosedYear" label="Chẩn đoán từ năm" :columns="{
              container: 5,
            }" :rules="['required']" :disabled="isDisabled" />
            <StaticElement name="p_9" tag="h4" content="KẾT QUẢ KHẢ NĂNG TỰ CHĂM SÓC" :columns="{
              container: 6,
            }" />
            <StaticElement name="p_10" tag="h4" :columns="{
              container: 6,
            }" content="KẾT QUẢ KHẢO SÁT KIẾN THỨC" />
            <GroupElement name="container4_1" class="border-group">
              <GroupElement name="column2_4" :columns="{
                container: 6,
              }" label="Mức độ kiến thức">
                <TextElement name="knowledgePoint" :columns="{
                  container: 8,
                }" :disabled="isDisabled" />
                <TextElement name="knowledgeAverage" label="Điểm  trung bình (/10)" :columns="{
                  container: 8,
                }" :disabled="isDisabled" />
              </GroupElement>
              <GroupElement name="column4_1" :columns="{
                container: 6,
              }">
                <TextElement name="selfCarePoint" label="Mức độ Tự Chăm sóc" :columns="{
                  container: 8,
                }" :disabled="isDisabled" />

                <TextElement name="selfCareAverage" label="Điểm  trung bình (/10)" :columns="{
                  container: 8,
                }" :disabled="isDisabled" />
              </GroupElement>
            </GroupElement>
          </GroupElement>
        <!-- /transition removed -->
        <!-- THÔNG TIN HÀNH CHÍNH END -->
        <StaticElement name="divider_thongtinhanhchinh" tag="hr" />
        <GroupElement :columns="{
          container: 9,
        }" name="containerTongTrang">
          <StaticElement name="title_Tongtrang" tag="h4" content="TỔNG TRẠNG" :columns="{ container: 4 }" />
          <div class="toggle-icon-container-tongtrang" @click="toggleTongTrang">
            <inline-svg :src="isShowTongTrang
              ? '/media/svg/icons/Neolex/Basic/circle-minus.svg'
              : '/media/svg/icons/Neolex/Basic/circle-plus.svg'
              " />
          </div>
        </GroupElement>
        <!-- transition removed for performance -->
          <GroupElement v-show="isShowTongTrang" class="border-group" name="tongtrang">
            <GroupElement class="border-group" name="column1" :columns="{
              container: 9,
            }">
              <TextElement name="weight" label="Cân nặng (kg)" :columns="{
                container: 4,
              }" :disabled="isDisabled" />
              <TextElement name="height" label="Chiều cao (cm)" :columns="{
                container: 4,
              }" :disabled="isDisabled" />
              <TextElement name="bmi" label="BMI (1 kg/m2)" :columns="{
                container: 4,
              }" :disabled="isDisabled" />
              <TextElement name="statusTongTrang" label="Tổng trạng" :disabled="isDisabled" />
            </GroupElement>
            <GroupElement name="issueTongTrangGroup" class="border-group" :columns="{
              container: 3,
            }">
              <StaticElement name="title_issueTongTrang" tag="h4" content="VẤN ĐỀ CỦA KHÁCH HÀNG" />
              <EditorElement name="issueTongTrang" :disabled="isDisabled" />
            </GroupElement>
          </GroupElement>
        <!-- /transition removed -->
        <!-- TINH THAN -->
        <StaticElement name="divider_tongtrang" tag="hr" />

        <GroupElement name="containerTinhThan">
          <StaticElement name="h4_19" tag="h4" content="TINH THẦN" :columns="{
            container: 3,
          }" />
          <div class="toggle-icon-container-tinhthan" @click="toggleTinhThan">
            <inline-svg :src="isShowTinhThan
              ? '/media/svg/icons/Neolex/Basic/circle-minus.svg'
              : '/media/svg/icons/Neolex/Basic/circle-plus.svg'
              " />
          </div>

          <!-- transition removed for performance -->
            <GroupElement name="container2_6" class="border-group" v-show="isShowTinhThan">
              <GroupElement name="column1" :columns="{
                container: 9,
              }">
                <GroupElement name="container2_7" class="border-group">
                  <GroupElement name="column1" :columns="{
                    container: 7,
                  }">
                    <StaticElement name="title_sleep_problem" tag="p"
                      content="Bạn có gặp vấn đề gì về giấc ngủ không (mất ngủ, ngủ không ngon giấc...)?" />
                  </GroupElement>
                  <GroupElement name="column101" :columns="{
                    container: 5,
                  }">
                    <RadiogroupElement name="sleepingProblem" view="tabs" :items="[
                      {
                        value: 1,
                        label: 'Không',
                      },
                      {
                        value: 0,
                        label: 'Có',
                      },
                    ]" :disabled="isDisabled" />
                  </GroupElement>
                </GroupElement>
                <GroupElement name="container2_8" class="border-group">
                  <GroupElement name="container2_9" class="border-group">
                    <GroupElement name="column1" :columns="{
                      container: 2,
                    }">
                      <StaticElement name="title_sleepingProblemExpand" tag="p" content="Vấn đề giấc ngủ" :columns="{
                        container: 10,
                      }" />
                    </GroupElement>
                    <GroupElement name="column102" :columns="{
                      container: 10,
                    }">
                      <GroupElement name="column2_6">
                        <CheckboxElement name="insomnia" text="Mất ngủ" :columns="{
                          container: 4,
                        }" :disabled="isDisabled" />
                        <CheckboxElement name="poorSleepQuality" text="Ngủ không ngon " :columns="{
                          container: 4,
                        }" :disabled="isDisabled" />
                        <CheckboxElement name="difficultyFallingAsleep" text="Khó bắt đầu giấc ngủ" :columns="{
                          container: 4,
                        }" :disabled="isDisabled" />
                        <CheckboxElement name="frequentWaking" text="Hay bị thức giấc " :columns="{
                          container: 4,
                        }" :disabled="isDisabled" />
                        <CheckboxElement name="useSleepingPills" text="Dùng thuốc ngủ " :columns="{
                          container: 4,
                        }" :disabled="isDisabled" />
                      </GroupElement>
                      <GroupElement name="column2_8" :columns="{
                        container: 12,
                      }">
                        <TextElement name="nightSleepingTime" label="Giờ ngủ tối(h)" :columns="{
                          default: {
                            container: 6,
                          },
                        }" :disabled="isDisabled" />
                        <TextElement name="middaySleepTime" label="Giờ ngủ trưa(h)" :columns="{
                          default: {
                            container: 6,
                          },
                        }" :disabled="isDisabled" />
                        <TextElement name="totalSleepTime" label="Tổng thời gian ngủ trong ngày(h)" :columns="{
                          default: {
                            container: 12,
                          },
                        }" :disabled="isDisabled" />
                      </GroupElement>
                    </GroupElement>
                  </GroupElement>
                  <GroupElement name="container2_10" class="border-group">
                    <GroupElement class="border-group" name="column2_9" :columns="{
                      container: 12,
                    }" :disabled="isDisabled">
                      <GroupElement name="column2_10">
                        <StaticElement name="title_anxiety" tag="p" content="Lo lắng" :columns="{
                          container: 3,
                        }" />
                        <RadiogroupElement name="optionProblemWorry" view="tabs" :items="[
                          {
                            value: 1,
                            label: 'Không',
                          },
                          {
                            value: 0,
                            label: 'Có',
                          },
                        ]" :columns="{
                          container: 3,
                        }" :disabled="isDisabled" />
                        <TextElement name="problemWorryText" placeholder="Vấn đề lo lắng" :columns="{
                          default: {
                            container: 4,
                          },
                        }" />
                      </GroupElement>
                      <GroupElement name="column2_12" :columns="{
                        container: 12,
                      }">
                        <StaticElement name="p_12" tag="p" content="Căng thẳng" :columns="{
                          container: 3,
                        }" />
                        <RadiogroupElement name="optionProblemStress" view="tabs" :items="[
                          {
                            value: 1,
                            label: 'Không',
                          },
                          {
                            value: 0,
                            label: 'Có',
                          },
                        ]" :columns="{
                          container: 3,
                        }" :disabled="isDisabled" />
                        <TextElement name="problemStressText" placeholder="Vấn đề căng thẳng" :columns="{
                          default: {
                            container: 4,
                          },
                        }" :disabled="isDisabled" />
                      </GroupElement>
                    </GroupElement>
                    <GroupElement name="column2_11" :columns="{
                      default: {
                        container: 10,
                      },
                      lg: {
                        container: 12,
                      },
                    }">
                    </GroupElement>
                    <GroupElement name="column2_13" class="border-group" :columns="{
                      default: {
                        container: 10,
                      },
                      lg: {
                        container: 12,
                      },
                    }">
                      <StaticElement name="p_13" tag="p"
                        content="Các biện pháp đang sử dụng để giảm căng thẳng, giảm lo lắng, rối loạn giấc ngủ (Nếu có)" />
                      <GroupElement name="column2_14" :columns="{
                        default: {
                          container: 10,
                        },
                        lg: {
                          container: 12,
                        },
                      }">
                        <CheckboxElement name="optRelax" :columns="{
                          default: {
                            container: 4,
                          },
                          lg: {
                            container: 2,
                          },
                        }" text="Thư giãn" :disabled="isDisabled" />
                        <CheckboxElement name="optMeditation" text="Thiền" :columns="{
                          default: {
                            container: 4,
                          },
                          lg: {
                            container: 2,
                          },
                        }" :disabled="isDisabled" />
                        <CheckboxElement name="optBreath" text="Hít thở" :columns="{
                          default: {
                            container: 4,
                          },
                          lg: {
                            container: 2,
                          },
                        }" :disabled="isDisabled" />
                        <TextElement name="otherReduceStressText" label="Khác" style="margin-top: -15px" :columns="{
                          default: {
                            container: 4,
                          },
                          lg: {
                            container: 4,
                          },
                        }" :disabled="isDisabled" />
                      </GroupElement>
                    </GroupElement>
                    <GroupElement class="border-group" name="column2_16" :columns="{
                      default: {
                        container: 12,
                      },
                    }">
                      <StaticElement name="p_14" tag="p" style="font-weight: bold" content="Tôn giáo, tín ngưỡng"
                        :columns="{
                          default: {
                            container: 3,
                          },
                        }" />
                      <CheckboxElement name="optTrustNo" :columns="{
                        default: {
                          container: 3,
                        },
                      }" text="Không" :disabled="isDisabled" />
                      <CheckboxElement name="optTrustBuddha" text="Phật giáo" :columns="{
                        default: {
                          container: 3,
                        },
                      }" :disabled="isDisabled" />
                      <CheckboxElement name="optTrusInChrist" text="Thiên chúa giáo" :columns="{
                        default: {
                          container: 3,
                        },
                      }" :disabled="isDisabled" />
                      <StaticElement name="title_space" :columns="{
                        default: {
                          container: 3,
                        },
                      }" />
                      <CheckboxElement name="optTrustIslam" text="Hồi giáo" :columns="{
                        default: {
                          container: 2,
                        },
                      }" :disabled="isDisabled" />
                      <TextElement style="margin-top: -15px" name="otherTrustText" label="Khác" :columns="{
                        default: {
                          container: 4,
                        },
                      }" :disabled="isDisabled" />
                    </GroupElement>

                    <GroupElement name="column2_17" :columns="{
                      default: {
                        container: 10,
                      },
                      lg: {
                        container: 12,
                      },
                    }">
                      <GroupElement class="border-group" name="column1_10" :columns="{
                        container: 12,
                      }">
                        <StaticElement name="p_15" tag="p" content="Khác" :columns="{
                          container: 2,
                        }" />
                        <TextElement name="otherReligionText" :columns="{
                          default: {
                            container: 10,
                          },
                        }" :disabled="isDisabled" />
                      </GroupElement>
                    </GroupElement>
                  </GroupElement>
                </GroupElement>
              </GroupElement>
              <GroupElement name="column99" :columns="{
                container: 3,
              }">
                <StaticElement name="h4_21" tag="h4" :columns="{
                  container: 12,
                }" content="VẤN ĐỀ CỦA KHÁCH HÀNG" />
                <EditorElement name="issueTinhThan" :disabled="isDisabled" />
              </GroupElement>
            </GroupElement>
          <!-- /transition removed -->
        </GroupElement>
        <StaticElement name="divider_tinhthan" tag="hr" />

        <GroupElement name="containerVanDong">
          <StaticElement name="h4_22" tag="h4" content="VẬN ĐỘNG" :columns="{
            container: 3,
          }" />
          <div class="toggle-icon-container-vandong" @click="toggleVanDong">
            <inline-svg :src="isShowVanDong
              ? '/media/svg/icons/Neolex/Basic/circle-minus.svg'
              : '/media/svg/icons/Neolex/Basic/circle-plus.svg'
              " />
          </div>

          <!-- transition removed for performance -->
            <GroupElement name="container2_12 " class="border-group" v-show="isShowVanDong">
              <GroupElement name="column1_8" :columns="{
                container: 9,
              }" class="border-group">
                <TextElement placeholder="Nhập số ngày"
                  label="Trong vòng 7 NGÀY qua, Có bao nhiêu ngày Bạn tham gia một môn thể dục thể thao cụ thể (như là bơi lội, đi bộ, đạp xe…) không bao gồm việc nhà hoặc công việc thường ngày? (ngày)"
                  name="activityOneWeek" :columns="{
                    lg: {
                      container: 12,
                    },
                  }" :disabled="isDisabled" />
                <TextElement placeholder="Nhập số ngày" name="activityOneWeek30min"
                  label="Trong vòng 7 NGÀY qua, Có bao nhiêu ngày Bạn vận động thể chất ít nhất 30 phút (tổng số phút của các hoạt động liên tục, bao gồm đi bộ)? (ngày)"
                  :columns="{
                    default: {
                      container: 12,
                    },
                  }" :disabled="isDisabled" />

                <GroupElement name="container2_15" class="border-group">
                  <StaticElement name="p_17" tag="p" content="Vận động thể chất" :columns="{
                    container: 3,
                  }" />

                  <RadiogroupElement name="activityWorkout" view="tabs" :items="[
                    {
                      value: 1,
                      label: 'Không',
                    },
                    {
                      value: 0,
                      label: 'Có (Nếu có hỏi tiếp những câu hỏi bên dưới)',
                    },
                  ]" :columns="{
                    container: 9,
                  }" :disabled="isDisabled" />
                </GroupElement>
                <GroupElement name="container2_16" class="border-group">
                  <GroupElement name="column1_13" :columns="{
                    default: {
                      container: 2,
                    },
                    lg: {
                      container: 3,
                    },
                  }">
                    <StaticElement name="physicalActivityType" tag="p" content="Loại hình vận động" :columns="{
                      container: 10,
                    }" />
                  </GroupElement>
                  <GroupElement name="column2_23" :columns="{
                    default: {
                      container: 10,
                    },
                    lg: {
                      container: 9,
                    },
                  }">
                    <GroupElement name="column2_24">
                      <CheckboxElement name="yoga" :columns="{
                        default: {
                          container: 4,
                        },
                        lg: {
                          container: 3,
                        },
                      }" text="Yoga" :disabled="isDisabled" />
                      <CheckboxElement name="swimming" text="Bơi lội" :columns="{
                        default: {
                          container: 4,
                        },
                        lg: {
                          container: 3,
                        },
                      }" :disabled="isDisabled" />
                      <CheckboxElement name="walking" text="Đi bộ" :columns="{
                        default: {
                          container: 4,
                        },
                        lg: {
                          container: 3,
                        },
                      }" :disabled="isDisabled" />
                      <CheckboxElement name="qigong" text="Dưỡng sinh " :columns="{
                        default: {
                          container: 4,
                        },
                        lg: {
                          container: 3,
                        },
                      }" :disabled="isDisabled" />
                      <CheckboxElement name="gym" text="Gym " :columns="{
                        default: {
                          container: 4,
                        },
                        lg: {
                          container: 3,
                        },
                      }" :disabled="isDisabled" />
                      <CheckboxElement name="cycling" text="Đạp xe" :columns="{
                        default: {
                          container: 4,
                        },
                        lg: {
                          container: 3,
                        },
                      }" :disabled="isDisabled" />
                      <CheckboxElement name="running" text="Chạy bộ" :columns="{
                        default: {
                          container: 4,
                        },
                        lg: {
                          container: 3,
                        },
                      }" :disabled="isDisabled" />
                      <CheckboxElement name="otherPhysicalActivity" text="Khác " :columns="{
                        default: {
                          container: 4,
                        },
                        lg: {
                          container: 3,
                        },
                      }" :disabled="isDisabled" />
                    </GroupElement>
                  </GroupElement>
                  <GroupElement name="column2_25" :columns="{
                    default: {
                      container: 10,
                    },
                    lg: {
                      container: 12,
                    },
                  }">
                    <GroupElement name="column1_14">
                      <StaticElement name="p_19" tag="p" content="Ngồi xem tivi/làm việc " :columns="{
                        container: 3,
                      }" />
                      <TextElement placeholder="giờ/ngày" name="text_37" :columns="{
                        default: {
                          container: 8,
                        },
                      }" :disabled="isDisabled" />
                      <StaticElement name="p_22" tag="p" content="Khác" :columns="{
                        container: 2,
                      }" />
                      <TextElement name="otherActivity" :columns="{
                        default: {
                          container: 9,
                        },
                      }" :disabled="isDisabled" />
                    </GroupElement>
                  </GroupElement>
                </GroupElement>
              </GroupElement>
              <GroupElement name="container2_17" :columns="{
                default: {
                  container: 3,
                },
              }">
                <StaticElement name="h4_23" tag="h4" :columns="{
                  container: 12,
                }" content="VẤN ĐỀ CỦA KHÁCH HÀNG" />
                <EditorElement name="issueWorkout" :columns="{
                  default: {
                    container: 12,
                  },
                }" :disabled="isDisabled" />
              </GroupElement>
            </GroupElement>
          <!-- /transition removed -->
        </GroupElement>
        <StaticElement />
        <StaticElement name="divider_vandong" tag="hr" />

        <GroupElement name="containerTienSuBenh">
          <StaticElement name="title_tiensubenh" tag="h4" content="TIỀN SỬ BỆNH" :columns="{
            container: 3,
          }" />
          <div class="toggle-icon-container-tiensubenh" @click="toggleTienSuBenh">
            <inline-svg :src="isShowTienSuBenh
              ? '/media/svg/icons/Neolex/Basic/circle-minus.svg'
              : '/media/svg/icons/Neolex/Basic/circle-plus.svg'
              " />
          </div>
        </GroupElement>

        <!-- transition removed for performance -->
          <GroupElement name="medicalHistoryGroup" class="border-group" v-show="isShowTienSuBenh">
            <GroupElement name="column1" :columns="{
              container: 9,
            }">
              <GroupElement name="containerMEDICAL" class="border-group">
                <StaticElement name="medicalHistoryQuestion" class="labeltext"
                  content="Bạn có các bệnh dưới đây không? ( KQKS )" :columns="{
                    container: 5,
                  }" />
                <TextElement name="medicalHistoryInput" :columns="{
                  container: 7,
                }" :disabled="isDisabled" />
              </GroupElement>
              <GroupElement name="container_1" class="border-group">
                <StaticElement name="title_hypoglycemiaQuestion" class="labeltext" input-type="number"
                  content="Hạ đường huyết" :columns="{
                    container: 3,
                  }" />

                <RadiogroupElement name="hypoglycemia" view="tabs" :items="[
                  {
                    value: 0,
                    label: 'Chưa bao giờ',
                  },
                  {
                    value: 1,
                    label: 'Thỉnh thoảng',
                  },
                  {
                    value: 2,
                    label: 'Thường xuyên',
                  },
                ]" :disabled="isDisabled" />
              </GroupElement>
              <GroupElement name="container_3" class="border-group">
                <StaticElement name="title_hypoglycemiaLevelQuestion" class="labeltext"
                  content="Đường huyết lúc hạ đường huyết" :columns="{
                    container: 6,
                  }" />
                <TextElement name="hypoglycemiaNumber" input-type="number" label="Chỉ số" :columns="{
                  container: 3,
                }" :disabled="isDisabled" />
                <SelectElement name="hypoglycemiaUnit" :items="[
                  {
                    value: 0,
                    label: 'mg/dl',
                  },
                  {
                    value: 1,
                    label: 'mmol/L',
                  },
                ]" :search="true" :native="false" label="Đơn vị" input-type="search" autocomplete="off" :columns="{
                  container: 3,
                }" :disabled="isDisabled" />
              </GroupElement>
              <GroupElement class="border-group" name="container_99">
                <GroupElement :columns="{
                  container: 3,
                }">
                  <StaticElement name="title_symptom" class="labeltext" content="Biểu hiện" :columns="{
                    container: 4,
                  }" />
                </GroupElement>
                <GroupElement :columns="{
                  container: 8,
                }">
                  <CheckboxElement name="sweating" text="Đổ mồ hôi" :columns="{
                    container: 3,
                  }" :disabled="isDisabled" />
                  <CheckboxElement name="shaking" text="Run tay" :columns="{
                    container: 3,
                  }" :disabled="isDisabled" />
                  <CheckboxElement name="anxiety" text="Lo lắng" :columns="{
                    container: 3,
                  }" :disabled="isDisabled" />
                  <CheckboxElement name="dizziness" text="Chóng mặt" :columns="{
                    container: 3,
                  }" :disabled="isDisabled" />
                  <CheckboxElement name="hunger" text="Đói" :columns="{
                    container: 3,
                  }" :disabled="isDisabled" />

                  <CheckboxElement name="rapidHeartbeat" text="Tim đập nhanh" :columns="{
                    container: 3,
                  }" :disabled="isDisabled" />
                  <CheckboxElement name="blurredVision" text="Nhìn mờ" :columns="{
                    container: 3,
                  }" :disabled="isDisabled" />
                  <CheckboxElement name="fatigue" text="Mệt mỏi" :columns="{
                    container: 3,
                  }" :disabled="isDisabled" />
                  <CheckboxElement name="headache" text="Đau đầu" :columns="{
                    container: 3,
                  }" :disabled="isDisabled" />
                  <CheckboxElement name="irritability" text="Cáu gắt" :columns="{
                    container: 3,
                  }" :disabled="isDisabled" />
                </GroupElement>
              </GroupElement>
              <GroupElement class="border-group" name="group_treatment1">
                <EditorElement label="Cách xử trí" class="labeltext" name="treatmentMethod" :columns="{
                  container: 12,
                }" :disabled="isDisabled" />
                <TextElement class="labeltext" label="Khác" name="otherQuestionTienSuBenh" :columns="{
                  container: 12,
                }" :disabled="isDisabled" />
              </GroupElement>
            </GroupElement>
            <GroupElement class="border-group" :columns="{
              container: 3,
            }" name="group_treatment2">
              <StaticElement name="medicalHistoryQuestion" tag="h4" content="VẤN ĐỀ CỦA KHÁCH HÀNG" />
              <EditorElement name="issueHistoryMedical" :disabled="isDisabled" />
            </GroupElement>
          </GroupElement>
        <!-- /transition removed -->

        <StaticElement name="divider_tiensubenh" tag="hr" />

        <GroupElement name="containerTienSuBenhXaHoi">
          <StaticElement name="title_TienSuBenhXH" tag="h4" content="TIỀN SỬ BỆNH XÃ HỘI" :columns="{
            container: 3,
          }" />
          <div class="toggle-icon-container-tiensubenhxahoi" @click="toggleTienSuBenhXaHoi">
            <inline-svg :src="isShowTienSuBenhXaHoi
              ? '/media/svg/icons/Neolex/Basic/circle-minus.svg'
              : '/media/svg/icons/Neolex/Basic/circle-plus.svg'
              " />
          </div>
        </GroupElement>
        <GroupElement class="border-group" v-show="isShowTienSuBenhXaHoi" name="containerTienSuBenhXaHoiExpand">
          <GroupElement>
            <GroupElement name="column1_2" :columns="{
              container: 9,
            }">
              <GroupElement name="container_8" class="border-group">
                <StaticElement name="labeltext_alcohol" class="labeltext"
                  content="Bạn có sử dụng rượu/bia không? ( KQKS )" :columns="{
                    container: 5,
                  }" />
                <TextElement name="alcoholUse" :columns="{
                  container: 7,
                }" placeholder=" (KQKS)" :disabled="isDisabled" />
              </GroupElement>
              <GroupElement name="container_9" class="border-group">
                <StaticElement name="title_frequency" class="labeltext" content="Tần suất:" :columns="{
                  container: 2,
                }" />
                <TextElement name="frequency" :columns="{
                  container: 5,
                }" placeholder=" (KQKS)" :disabled="isDisabled" />
              </GroupElement>
              <GroupElement name="container_14" class="border-group">
                <StaticElement name="title_amount" class="labeltext" content="Số lượng:" :columns="{
                  container: 2,
                }" />
                <TextElement input-type="number" name="amount" :columns="{
                  container: 5,
                }" placeholder=" (KQKS)" :disabled="isDisabled" />
                <StaticElement name="title_unit" content=" (ml/lần) " :columns="{
                  container: 2,
                }" />
              </GroupElement>
              <GroupElement name="container_11" class="border-group">
                <StaticElement name="title_smoking" class="labeltext" content="Hiện tại bạn có hút thuốc lá không?"
                  :columns="{
                    container: 6,
                  }" />
                <RadiogroupElement name="smokingStatus" view="tabs" :items="[
                  {
                    value: 1,
                    label: 'Không',
                  },
                  {
                    value: 0,
                    label: 'Có',
                  },
                ]" :disabled="isDisabled" />
                <StaticElement name="title_unit" content=" " :columns="{
                  container: 1,
                }" />
              </GroupElement>
              <GroupElement name="container_12" class="border-group">
                <StaticElement name="title_average_smoking" class="labeltext"
                  content="Trung bình Bạn hút bao nhiêu điếu một ngày " :columns="{
                    container: 7,
                  }" />
                <TextElement style="margin-top: -10px" name="averageCigarettesPerDay" :columns="{
                  container: 2,
                }" :disabled="isDisabled" />
                <StaticElement name="title_unit_inday" content="điếu/ngày" :columns="{
                  container: 1,
                }" />
              </GroupElement>
              <GroupElement name="container_10" class="border-group">
                <StaticElement name="title_mostly_smoking" class="labeltext"
                  content="Khi nào Bạn thấy mình sử dụng thuốc lá nhiều nhất trong ngày?" :columns="{
                    container: 7,
                  }" />
                <TextElement style="margin-top: -10px" name="whenMostlySmoke" :columns="{
                  container: 2,
                }" :disabled="isDisabled" />
              </GroupElement>
              <GroupElement name="container_13" class="border-group">
                <CheckboxElement class="labeltext" name="livingAlone" text=" Sống một mình" :columns="{
                  container: 4,
                }" />

                <TextElement class="labeltext" style="margin-top: -10px" name="livingWithSomeone"
                  label="Sống chung với:" :columns="{
                    container: 6,
                  }" :disabled="isDisabled" />
                <StaticElement name="title_ismainpillar" class="labeltext" content="Trụ cột chính trong gia đình? "
                  :columns="{
                    container: 4,
                  }" />
                <RadiogroupElement name="mainPillar" view="tabs" :items="[
                  {
                    value: 1,
                    label: 'Không',
                  },
                  {
                    value: 0,
                    label: 'Có',
                  },
                ]" :disabled="isDisabled" />
                <TextElement class="labeltext" label="Khác" name="otherBenhXh" :columns="{
                  container: 12,
                }" :disabled="isDisabled" />
              </GroupElement>
            </GroupElement>
            <GroupElement class="border-group" :columns="{
              container: 3,
            }" name="group_treatment3">
              <StaticElement name="HistoryMedical" tag="h4" content="VẤN ĐỀ CỦA KHÁCH HÀNG" />
              <EditorElement name="issueHistoryMedicalXh" :disabled="isDisabled" />
            </GroupElement>
          </GroupElement>
        </GroupElement>

        <GroupElement name="containerDuongHuyet">
          <StaticElement name="titleDuongHuyet" tag="h4" content="THEO DÕI ĐƯỜNG HUYẾT" :columns="{ container: 3 }" />
          <div class="toggle-icon-container-duonghuyet">
            <span @click="toggleDuongHuyet">
              <inline-svg :src="isShowDuongHuyet
                ? '/media/svg/icons/Neolex/Basic/circle-minus.svg'
                : '/media/svg/icons/Neolex/Basic/circle-plus.svg'
                " />
            </span>
          </div>
        </GroupElement>
        <!-- transition removed for performance -->
          <GroupElement name="DuongHuyetExpand" v-show="isShowDuongHuyet">
            <GroupElement name="groupDuongHuyet1" class="border-group">
              <GroupElement name="groupDuongHuyet2" :columns="{
                container: 9,
              }">
                <GroupElement name="groupDuongHuyet3">
                  <GroupElement name="groupDuongHuyet4" class="border-group">
                    <StaticElement name="staticDuongHuyet1" :columns="{
                      container: 7,
                    }" tag="p" content="Trong vòng 7 NGÀY qua, Có bao nhiêu ngày Bạn đo đường huyết?
" />
                    <TextElement placeholder="ngày" name="oneWeekFollowGlucose" :columns="{
                      container: 5,
                    }" :disabled="isDisabled" />
                  </GroupElement>
                </GroupElement>
                <GroupElement name="groupDuongHuyet5" class="border-group">
                  <StaticElement name="staticDuongHuyet2" tag="p"
                    content="Trong vòng 7 NGÀY qua, Có bao nhiêu ngày Bạn đo đường huyết theo số lần bác sĩ của bạn khuyến nghị?"
                    :columns="{
                      container: 7,
                    }" />
                  <TextElement placeholder="ngày" name="oneWeekFollowDoctor" :columns="{
                    container: 5,
                  }" :disabled="isDisabled" />
                </GroupElement>
                <GroupElement name="container_18" class="border-group">
                  <TextElement name="hba1c" :columns="{
                    default: {
                      container: 8,
                    },
                    lg: {
                      container: 4,
                    },
                  }" label="HbA1c (%)" :disabled="isDisabled" />
                  <DateElement name="hba1cDate" label="Ngày xét nghiệm" :columns="{
                    default: {
                      container: 8,
                    },
                    lg: {
                      container: 6,
                    },
                  }" :disabled="isDisabled" />

                  <TextElement name="glucose" :columns="{
                    default: {
                      container: 8,
                    },
                    lg: {
                      container: 4,
                    },
                  }" label="Đường huyết đói " :disabled="isDisabled" />
                  <DateElement name="glucoseDate" label="Ngày đo" :columns="{
                    default: {
                      container: 8,
                    },
                    lg: {
                      container: 6,
                    },
                  }" :disabled="isDisabled" />

                  <TextElement name="glucoseAfter2Hours" :columns="{
                    default: {
                      container: 8,
                    },
                    lg: {
                      container: 4,
                    },
                  }" label="Đường huyết 2 giờ sau ăn" :disabled="isDisabled" />
                  <DateElement name="glucoseAfter2HoursDate" label="Ngày đo" :columns="{
                    default: {
                      container: 8,
                    },
                    lg: {
                      container: 6,
                    },
                  }" :disabled="isDisabled" />

                  <TextElement name="otherGlucose" label="Khác" :disabled="isDisabled" />
                </GroupElement>
              </GroupElement>
              <GroupElement name="column2_22" :columns="{
                container: 3,
              }">
                <StaticElement name="h4_25" tag="h4" :columns="{
                  container: 12,
                }" content="VẤN ĐỀ CỦA KHÁCH HÀNG" />
                <EditorElement name="issueGlucose" :disabled="isDisabled" />
              </GroupElement>
            </GroupElement>
          </GroupElement>
        <!-- /transition removed -->
        <StaticElement name="divide-Chamsocbanchan" tag="hr" />

        <GroupElement name="containerBanChan">
          <StaticElement name="titlecsBanChan" tag="h4" content="CHĂM SÓC BÀN CHÂN " :columns="{ container: 3 }" />
          <div class="toggle-icon-container-chamsocbanchan">
            <span @click="togglechamSocBanChan">
              <inline-svg :src="isShowBanChan
                ? '/media/svg/icons/Neolex/Basic/circle-minus.svg'
                : '/media/svg/icons/Neolex/Basic/circle-plus.svg'
                " />
            </span>
          </div>
        </GroupElement>
        <!-- transition removed for performance -->
          <GroupElement name="BanChanExpand" v-show="isShowBanChan">
            <GroupElement name="container2_19" class="border-group">
              <GroupElement name="column1_18" :columns="{
                container: 9,
              }">
                <GroupElement name="container_4">
                  <GroupElement name="container2_20" class="border-group">
                    <StaticElement name="h4_26" :columns="{
                      container: 7,
                    }" tag="p"
                      content="Trong vòng 7 NGÀY qua, Có bao nhiêu ngày Bạn kiểm tra bàn chân của mình? (Kiểm tra lòng bàn chân, cảm giác của bàn chân, khe bàn chân,…)" />
                    <TextElement placeholder="ngày" name="oneWeekCheckFoot" :columns="{
                      container: 5,
                    }" :disabled="isDisabled" />
                  </GroupElement>
                </GroupElement>
                <GroupElement name="container_17" class="border-group">
                  <StaticElement name="h4_28" tag="p"
                    content="Trong vòng 7 NGÀY qua, Có bao nhiêu ngày Bạn kiểm tra bên trong giày của mình? (Có vật lạ,…)"
                    :columns="{
                      container: 7,
                    }" />
                  <TextElement placeholder="ngày" name="oneWeekCheckBoost" :columns="{
                    container: 5,
                  }" :disabled="isDisabled" />
                </GroupElement>
                <GroupElement name="container_23" class="border-group">
                  <StaticElement name="title_ismainpillar" content="Khám biến chứng bàn chân Đái tháo đường" :columns="{
                    container: 4,
                  }" />
                  <RadiogroupElement name="optFootComplication" view="tabs" :items="[
                    {
                      value: 1,
                      label: 'Không',
                    },
                    {
                      value: 0,
                      label: 'Có',
                    },
                  ]" :columns="{
                    container: 8,
                  }" :disabled="isDisabled" />
                  <TextElement name="otherFootComplication" label="Khác" :disabled="isDisabled" />
                </GroupElement>
              </GroupElement>
              <GroupElement name="column2_22" :columns="{
                container: 3,
              }">
                <StaticElement name="h4_25" tag="h4" :columns="{
                  container: 12,
                }" content="VẤN ĐỀ CỦA KHÁCH HÀNG" />
                <EditorElement name="issueFoot" :disabled="isDisabled" />
              </GroupElement>
            </GroupElement>
          </GroupElement>
        <!-- /transition removed -->

        <StaticElement name="divide-SuDungThuoc" tag="hr" />

        <GroupElement name="containerSuDungThuoc">
          <StaticElement name="titleSuDungThuoc" tag="h4" content="SỬ DỤNG THUỐC" :columns="{ container: 3 }" />
          <div class="toggle-icon-container-sudungthuoc">
            <span @click="toggleSuDungThuoc">
              <inline-svg :src="isShowSuDungThuoc
                ? '/media/svg/icons/Neolex/Basic/circle-minus.svg'
                : '/media/svg/icons/Neolex/Basic/circle-plus.svg'
                " />
            </span>
          </div>
        </GroupElement>
        <!-- transition removed for performance -->
          <GroupElement name="expandSuDungThuoc" v-show="isShowSuDungThuoc" class="border-group">
            <GroupElement name="column1" :columns="{
              default: {
                container: 9,
              },
              lg: {
                container: 9,
              },
            }">
              <GroupElement name="container_20">
                <GroupElement name="container2_24" :columns="{
                  lg: {
                    container: 12,
                  },
                }">
                  <StaticElement name="h4_36" tag="p" content="Thuốc tiểu đường đang sử dụng" :columns="{
                    default: {
                      container: 4,
                    },
                  }" />
                  <RadiogroupElement name="optDiabetesMedications" view="tabs" :items="[
                    {
                      value: 1,
                      label: 'Không',
                    },
                    {
                      value: 0,
                      label: 'Có',
                    },
                  ]" :columns="{
                    container: 6,
                  }" :disabled="isDisabled" />
                </GroupElement>
                <GroupElement name="container2_37" :columns="{
                  lg: {
                    container: 12,
                  },
                }">
                  <StaticElement name="h4_33" tag="p" content="Chi tiết thuốc" :columns="{
                    default: {
                      container: 4,
                    },
                  }" />
                  <MultifileElement name="descriptionMedicalImage" label="Thêm hình ảnh" view="image" accept="image/*"
                    :file="{
                      rules: [
                        'mimetypes:image/jpeg,image/png,image/gif,image/webp,image/svg+xml,image/tiff',
                      ],
                    }" :columns="{
                      default: {
                        container: 3,
                      },
                      lg: {
                        container: 3,
                      },
                    }" :drop="false" :disabled="isDisabled" />



                  <MultifileElement name="descriptionMedicalFile" label="Thêm tài liệu" :columns="{
                    lg: {
                      container: 3,
                    },
                    default: {
                      container: 6,
                    },
                  }" :drop="false" :disabled="isDisabled" />
                  <StaticElement name="h4_202" tag="p" :columns="{
                    default: {
                      container: 4,
                    },
                  }" />
                  <ButtonElement name="buttonShowImage" @click="openImage" v-if="!isEdit && isDisabled" :columns="{
                    default: {
                      container: 3,
                    },
                  }" :condition="[[
                    'buttonEdit',
                    'empty',
                  ]]">
                    Tải Hình
                  </ButtonElement>
                  <ButtonElement name="buttonShowFile" @click="openFile" v-if="!isEdit && isDisabled" :columns="{
                    default: {
                      container: 3,
                    },
                  }" :condition="[[
                    'buttonEdit',
                  ]]">
                    Tải File
                  </ButtonElement>
                </GroupElement>
                <GroupElement name="container2_38" :columns="{
                  lg: {
                    container: 12,
                  },
                }">
                  <StaticElement name="h4_34" tag="p" content="Tuân thủ dùng thuốc" :columns="{
                    default: {
                      container: 3,
                    },
                    lg: {
                      container: 4,
                    },
                  }" />
                  <GroupElement name="container_19" :columns="{
                    default: {
                      container: 9,
                    },
                    lg: {
                      container: 8,
                    },
                  }">
                    <CheckboxElement name="notUseMedicine" :columns="{
                      default: {
                        container: 5,
                      },
                      lg: {
                        container: 6,
                      },
                    }" text="Không muốn dùng thuốc" :disabled="isDisabled" />
                    <CheckboxElement name="forgotMedicine" :columns="{
                      default: {
                        container: 7,
                      },
                      lg: {
                        container: 6,
                      },
                    }" text="Quên thường xuyên" :disabled="isDisabled" />
                    <CheckboxElement name="sometimeForgotMedicine" :columns="{
                      default: {
                        container: 5,
                      },
                      lg: {
                        container: 6,
                      },
                    }" text="Thỉnh thoảng quên  " :disabled="isDisabled" />
                    <CheckboxElement name="followMedicine" :columns="{
                      default: {
                        container: 6,
                      },
                      lg: {
                        container: 6,
                      },
                    }" text="Tuân thủ tốt" :disabled="isDisabled" />
                  </GroupElement>
                  <TextElement name="otherUsingMedical" label="Khó khăn khi dùng thuốc " :disabled="isDisabled" />
                </GroupElement>
              </GroupElement>
            </GroupElement>
            <GroupElement name="column100" :columns="{
              default: {
                container: 3,
              },
              lg: {
                container: 3,
              },
            }">
              <StaticElement name="h4_31" tag="h4" :columns="{
                container: 12,
              }" content="VẤN ĐỀ CỦA KHÁCH HÀNG" />
              <EditorElement name="issueUsingMedical" :disabled="isDisabled" />
            </GroupElement>
          </GroupElement>
        <!-- /transition removed -->
        <StaticElement name="divide-HocTap" tag="hr" />

        <GroupElement name="containerHocTap">
          <StaticElement name="titleSuDungThuoc" tag="h4" content="KHẢ NĂNG HỌC TẬP" :columns="{ container: 3 }" />
          <div class="toggle-icon-container-hoctap">
            <span @click="toggleHocTap">
              <inline-svg :src="isShowHocTap
                ? '/media/svg/icons/Neolex/Basic/circle-minus.svg'
                : '/media/svg/icons/Neolex/Basic/circle-plus.svg'
                " />
            </span>
          </div>
        </GroupElement>
        <GroupElement name="containerHocTapExpand" v-show="isShowHocTap" class="border-group">
          <GroupElement name="column1_23" :columns="{
            default: {
              container: 9,
            },
            lg: {
              container: 9,
            },
          }">
            <GroupElement name="container_26">
              <GroupElement name="container2_26" :columns="{
                lg: {
                  container: 12,
                },
              }">
                <StaticElement name="h4_37" tag="p" content="Bạn học tốt nhất thông qua:" :columns="{
                  default: {
                    container: 3,
                  },
                  lg: {
                    container: 4,
                  },
                }" />
                <CheckboxElement name="listen" :columns="{
                  default: {
                    container: 1,
                  },
                  lg: {
                    container: 2,
                  },
                }" text="Nghe " :disabled="isDisabled" />
                <CheckboxElement name="read" text="Nhìn" :columns="{
                  default: {
                    container: 1,
                  },
                  lg: {
                    container: 2,
                  },
                }" :disabled="isDisabled" />
                <CheckboxElement name="image" text="Hình ảnh" :columns="{
                  default: {
                    container: 2,
                  },
                  lg: {
                    container: 2,
                  },
                }" :disabled="isDisabled" />
                <CheckboxElement name="action" text="Làm/thực hành" :columns="{
                  default: {
                    container: 2,
                  },
                  lg: {
                    container: 2,
                  },
                }" :disabled="isDisabled" />
              </GroupElement>
              <GroupElement name="container2_40" :columns="{
                lg: {
                  container: 12,
                },
              }">
                <StaticElement name="h4_39" tag="p" content="Rào cản/khó khăn trong học tập:" :columns="{
                  default: {
                    container: 3,
                  },
                  lg: {
                    container: 4,
                  },
                }" />
                <GroupElement name="container_27" :columns="{
                  default: {
                    container: 9,
                  },
                  lg: {
                    container: 8,
                  },
                }">
                  <CheckboxElement name="problemLanguage" :columns="{
                    default: {
                      container: 4,
                    },
                    lg: {
                      container: 6,
                    },
                  }" text="Rào cản ngôn ngữ " :disabled="isDisabled" />
                  <CheckboxElement name="problemEyes" :columns="{
                    default: {
                      container: 4,
                    },
                    lg: {
                      container: 6,
                    },
                  }" text="Giảm thị lực" :disabled="isDisabled" />
                  <CheckboxElement name="problemEducation" :columns="{
                    default: {
                      container: 4,
                    },
                    lg: {
                      container: 6,
                    },
                  }" text="Trình độ học vấn" :disabled="isDisabled" />
                  <CheckboxElement name="problemListen" :columns="{
                    default: {
                      container: 4,
                    },
                    lg: {
                      container: 6,
                    },
                  }" text="Giảm thính lực" :disabled="isDisabled" />
                  <CheckboxElement name="problemCulture" :columns="{
                    default: {
                      container: 4,
                    },
                    lg: {
                      container: 6,
                    },
                  }" text="Khác biệt văn hóa " :disabled="isDisabled" />
                  <CheckboxElement name="problemTechnology" :columns="{
                    default: {
                      container: 3,
                    },
                    lg: {
                      container: 6,
                    },
                  }" text="Khả năng sử dụng CN " />
                </GroupElement>

                <TextElement name="otherLearning" label="Khác" :disabled="isDisabled" />
              </GroupElement>
            </GroupElement>
          </GroupElement>
          <GroupElement name="column2_36" :columns="{
            default: {
              container: 3,
            },
            lg: {
              container: 3,
            },
          }">
            <StaticElement name="h4_35" tag="h4" :columns="{
              container: 12,
            }" content="VẤN ĐỀ CỦA KHÁCH HÀNG" />
            <EditorElement name="issueLearning" :disabled="isDisabled" />
          </GroupElement>
        </GroupElement>

        <GroupElement name="containerDinhDuong">
          <StaticElement name="h4_52" tag="h4" content="DINH DƯỠNG" :columns="{
            container: 3,
          }" />

          <div class="toggle-icon-container-dinhduong">
            <span @click="toggleDinhDuong">
              <inline-svg :src="isShowDinhDuong
                ? '/media/svg/icons/Neolex/Basic/circle-minus.svg'
                : '/media/svg/icons/Neolex/Basic/circle-plus.svg'
                " />
            </span>
          </div>

          <GroupElement name="container2_28" v-show="isShowDinhDuong" class="border-group">
            <GroupElement name="column1_26" :columns="{
              container: 9,
            }">
              <GroupElement name="container2_29">
                <GroupElement name="column1_27" :columns="{
                  container: 12,
                }" class="border-group">
                  <StaticElement name="oneWeekEatCleanStatic" tag="p" content="Trong vòng 7 NGÀY qua, Có bao nhiêu ngày Bạn ăn theo chế độ ăn uống lành mạnh?
" :columns="{
  container: 9,
}" />
                  <TextElement placeholder="Nhập số ngày" name="oneWeekEatClean" :columns="{
                    container: 3,
                  }" :disabled="isDisabled" />
                </GroupElement>
              </GroupElement>
              <GroupElement name="container_22" class="border-group">
                <StaticElement name="h4_57" tag="p"
                  content="Trung bình trong THÁNG QUA, Có bao nhiêu ngày mỗi tuần Bạn ăn theo chế độ ăn của mình?"
                  :columns="{
                    container: 9,
                  }" />
                <TextElement placeholder="Nhập số ngày" name="oneMonthEatClean" :columns="{
                  container: 3,
                }" :disabled="isDisabled" />
              </GroupElement>
              <GroupElement name="container_23" class="border-group">
                <StaticElement name="h4_59" tag="p"
                  content="Trong vòng 7 NGÀY qua, Có bao nhiêu ngày Bạn ăn 3 suất trái cây và hơn 3 suất rau củ?"
                  :columns="{
                    container: 9,
                  }" />
                <TextElement placeholder="Nhập số ngày" name="oneWeekEatVegetable" :columns="{
                  container: 3,
                }" :disabled="isDisabled" />
              </GroupElement>
              <GroupElement name="container_24" class="border-group">
                <StaticElement name="h4_61" tag="p"
                  content="Trong vòng 7 NGÀY qua, Có bao nhiêu ngày Bạn ăn thức ăn có lượng béo cao như thịt đỏ, hoặc các sản phẩm từ sữa nguyên kem?"
                  :columns="{
                    container: 9,
                  }" />
                <TextElement placeholder="Nhập số ngày" name="oneWeekEatHighProtein" :columns="{
                  container: 3,
                }" :disabled="isDisabled" />
              </GroupElement>
              <GroupElement name="container_25" class="border-group">
                <StaticElement name="h4_63" tag="h4" content="Dị ứng thức ăn" :columns="{
                  container: 12,
                }" />
                <GroupElement name="container2_33" class="border-group">
                  <RadiogroupElement name="problemFood" view="tabs" :items="[
                    {
                      value: 1,
                      label: 'Không',
                    },
                    {
                      value: 0,
                      label: 'Có',
                    },
                  ]" :columns="{
                    container: 12,
                  }" :disabled="isDisabled" />
                </GroupElement>
                <StaticElement name="h4_64" tag="h4" content="Mô tả một ngày ăn uống" :columns="{
                  container: 12,
                }" />
                <GroupElement name="container2_34" class="border-group">
                  <StaticElement name="h4_65" tag="p" content="Sáng" :columns="{
                    container: 3,
                  }" />

                  <TextElement name="morning" :columns="{
                    container: 9,
                  }" :disabled="isDisabled" />
                  <StaticElement name="h4_66" tag="p" content="Phụ 1" :columns="{
                    container: 3,
                  }" />
                  <TextElement name="subOne" :columns="{
                    container: 9,
                  }" :disabled="isDisabled" />
                  <StaticElement name="h4_67" tag="p" content="Trưa" :columns="{
                    container: 3,
                  }" />
                  <TextElement name="midday" :columns="{
                    container: 9,
                  }" :disabled="isDisabled" />
                  <StaticElement name="h4_68" tag="p" content="Phụ 2" :columns="{
                    container: 3,
                  }" />
                  <TextElement name="subTwo" :columns="{
                    container: 9,
                  }" :disabled="isDisabled" />
                  <StaticElement name="h4_69" tag="p" content="Chiều" :columns="{
                    container: 3,
                  }" />
                  <TextElement name="afternoon" :columns="{
                    container: 9,
                  }" :disabled="isDisabled" />
                  <StaticElement name="h4_70" tag="p" content="Phụ 3" :columns="{
                    container: 3,
                  }" />
                  <TextElement name="subThree" :columns="{
                    container: 9,
                  }" :disabled="isDisabled" />
                </GroupElement>
                <StaticElement name="h4_71" tag="h4" content="Thói quen ăn uống " :columns="{
                  container: 12,
                }" />
                <GroupElement name="container2_35" class="border-group">
                  <GroupElement name="column1_33">
                    <StaticElement name="h4_72" tag="p" content="Số bữa chính" :columns="{
                      container: 2,
                    }" />
                    <TextElement name="mainDiet" :columns="{
                      container: 9,
                    }" :disabled="isDisabled" />
                    <StaticElement name="h4_73" tag="p" content="Số bữa phụ" :columns="{
                      container: 2,
                    }" />
                    <TextElement name="subDiet" :columns="{
                      container: 9,
                    }" :disabled="isDisabled" />
                    <StaticElement name="h4_74" tag="p" content="Ăn vặt" :columns="{
                      container: 4,
                    }" />
                    <RadiogroupElement name="optstreetFood" view="tabs" :items="[
                      {
                        value: 1,
                        label: 'Không',
                      },
                      {
                        value: 0,
                        label: 'Có',
                      },
                    ]" :columns="{
                      container: 7,
                    }" :disabled="isDisabled" />
                    <TextElement placeholder="Ghi chú ghi rõ món ăn vặt" name="streedFood" :columns="{
                      container: 12,
                    }" :disabled="isDisabled" />

                    <StaticElement name="h4_75" tag="p" content="Ăn đúng giờ" :columns="{
                      container: 4,
                    }" />
                    <RadiogroupElement name="optEatingRighttime" view="tabs" :items="[
                      {
                        value: 1,
                        label: 'Không',
                      },
                      {
                        value: 0,
                        label: 'Có',
                      },
                    ]" :columns="{
                      container: 7,
                    }" :disabled="isDisabled" />
                    <StaticElement name="h4_76" tag="p" content="Ăn ngoài" :columns="{
                      container: 4,
                    }" />
                    <RadiogroupElement name="optEatingOutside" view="tabs" :items="[
                      {
                        value: 0,
                        label: 'Không',
                      },
                      {
                        value: 1,
                        label: 'Thỉnh thoảng',
                      },
                      {
                        value: 2,
                        label: 'Thường xuyên',
                      },
                    ]" :columns="{
                      container: 8,
                    }" :disabled="isDisabled" />
                    <StaticElement name="h4_76" tag="p" content="Ăn ngọt" :columns="{
                      container: 4,
                    }" />
                    <RadiogroupElement name="optEatingSugar" view="tabs" :items="[
                      {
                        value: 0,
                        label: 'Không',
                      },
                      {
                        value: 1,
                        label: 'Thỉnh thoảng',
                      },
                      {
                        value: 2,
                        label: 'Thường xuyên',
                      },
                    ]" :columns="{
                      container: 8,
                    }" :disabled="isDisabled" />
                    <StaticElement name="h4_78" tag="p" content="Lượng nước uống trong ngày ( lít/ngày
 )" :columns="{
  container: 6,
}" />
                    <TextElement name="drinkWater" :columns="{
                      container: 6,
                    }" :disabled="isDisabled" />
                    <StaticElement name="h4_79" tag="p" content="Loại nước uống trong ngày :" :columns="{
                      container: 6,
                    }" />
                    <TextElement name="typeOfWater" :columns="{
                      container: 6,
                    }" :disabled="isDisabled" />
                    <StaticElement name="h4_80" tag="p" content="Mức kcal/ngày theo khuyến nghị " :columns="{
                      container: 6,
                    }" />
                    <TextElement name="kcal" :columns="{
                      container: 6,
                    }" :disabled="isDisabled" />
                    <StaticElement name="h4_81" tag="p" content="Nguyên tắc Thực đơn" :columns="{
                      container: 6,
                    }" />
                    <CheckboxElement name="ruleOfMenu" text="Gửi thực đơn cho KH " :columns="{
                      container: 6,
                    }" :disabled="isDisabled" />
                    <TextElement name="otherDiet" label="Khác" :disabled="isDisabled" />
                  </GroupElement>
                </GroupElement>
              </GroupElement>
            </GroupElement>
            <GroupElement name="column2_45" :columns="{
              container: 3,
            }">
              <StaticElement name="h4_54" tag="h4" :columns="{
                container: 12,
              }" content="VẤN ĐỀ CỦA KHÁCH HÀNG" />
              <EditorElement name="issueNutrion" :disabled="isDisabled" />
            </GroupElement>
          </GroupElement>
        </GroupElement>
        <GroupElement name="containerDLVMT" class="border-group">
          <StaticElement name="h2" tag="h4" content="ĐỘNG LỰC " />

          <GroupElement name="containerDL" class="border-group">
            <EditorElement name="motivation" :disabled="isDisabled" />
          </GroupElement>
          <StaticElement name="divider_DLMT" tag="hr" />

          <StaticElement name="h2" tag="h4"
            content="TRỞ NGẠI (KHÓ KHĂN) (khi tham gia chương trình và mục tiêu đạt được)" />

          <GroupElement name="containerTN" class="border-group">
            <EditorElement name="problemMotivation" :disabled="isDisabled" />
          </GroupElement>
          <StaticElement name="divider_DLMT" tag="hr" />

          <StaticElement name="h2" tag="h4" content="MỨC ĐỘ TỰ TIN" />

          <GroupElement name="containerMDTT" class="border-group">
            <EditorElement name="confidentLevel" :disabled="isDisabled" />
          </GroupElement>
          <StaticElement name="divider_DLMT" tag="hr" />

          <StaticElement name="h2" tag="h4" content="VẤN ĐỀ CỦA KHÁCH HÀNG" />

          <GroupElement name="containerVDKH" class="border-group">
            <EditorElement name="issueMotivation" :disabled="isDisabled" />
          </GroupElement>
          <StaticElement name="divider_DLMT" tag="hr" />

          <GroupElement name="containerMuctieu" :columns="{
            container: 12,
          }">
            <StaticElement name="title_containerMuctieu" tag="h4" content="MỤC TIÊU" :columns="{
              container: 2,
            }" />
            <!-- <div class="toggle-icon-container-muctieu">
              <span @click="toggleMuctieu">
                <inline-svg :src="isShowMuctieu
                  ? '/media/svg/icons/Neolex/Basic/circle-minus.svg'
                  : '/media/svg/icons/Neolex/Basic/circle-plus.svg'
                  " />
              </span>
            </div> -->
          </GroupElement>
          <!-- <GroupElement name="container2_41" class="border-group" v-show="isShowMuctieu"> -->
          <GroupElement name="container2_41" class="border-group">
            <StaticElement name="h2_6" tag="h4" content="MỤC TIÊU CHƯƠNG TRÌNH" />
            <GroupElement name="container2_445" class="border-group">
              <GroupElement name="container_hba1c">
                <StaticElement name="h2_6" tag="p" class="labeltext" content="HbA1c" :columns="{
                  container: 2,
                }" />
                <RadiogroupElement name="optionsHba1c" view="tabs" :items="[
                  {
                    value: 0,
                    label: 'Thấp hơn',
                  },
                  {
                    value: 1,
                    label: 'Duy trì',
                  },
                  {
                    value: 2,
                    label: 'Cao hơn',
                  },
                ]" :columns="{
                  container: 3,
                }" :disabled="isDisabled" />
                <TextElement name="hbA1cInput" placeholder="%" input-type="number" :columns="{
                  container: 1,
                }" :disabled="isDisabled" />
              </GroupElement>
              <GroupElement name="container_weight">
                <StaticElement name="h2_6" tag="p" class="labeltext" content="Cân nặng" :columns="{
                  container: 2,
                }" />
                <RadiogroupElement name="optionsWeight" view="tabs" :items="[
                  {
                    value: 0,
                    label: 'Thấp hơn',
                  },
                  {
                    value: 1,
                    label: 'Duy trì',
                  },
                  {
                    value: 2,
                    label: 'Cao hơn',
                  },
                ]" :columns="{
                  container: 3,
                }" :disabled="isDisabled" />
                <TextElement name="weightInput" placeholder="kg" input-type="number" :columns="{
                  container: 1,
                }" :disabled="isDisabled" />
              </GroupElement>
              <GroupElement name="container_knowledge">
                <StaticElement name="h2_6" tag="p" class="labeltext" content="Kiến thức" :columns="{
                  container: 2,
                }" />
                <RadiogroupElement name="optionsKnowledge" view="tabs" :items="[
                  {
                    value: 0,
                    label: 'Thấp hơn',
                  },
                  {
                    value: 1,
                    label: 'Duy trì',
                  },
                  {
                    value: 2,
                    label: 'Cao hơn',
                  },
                ]" :columns="{
                  container: 3,
                }" :disabled="isDisabled" />
                <TextElement name="knowledgeInput" placeholder="điểm" input-type="number" :columns="{
                  container: 1,
                }" :disabled="isDisabled" />
              </GroupElement>
              <GroupElement name="container_kntcs">
                <StaticElement name="h2_6" tag="p" class="labeltext" content="Khả năng tự CS" :columns="{
                  container: 2,
                }" />
                <RadiogroupElement name="optionsKntcs" view="tabs" :items="[
                  {
                    value: 0,
                    label: 'Thấp hơn',
                  },
                  {
                    value: 1,
                    label: 'Duy trì',
                  },
                  {
                    value: 2,
                    label: 'Cao hơn',
                  },
                ]" :columns="{
                  container: 3,
                }" :disabled="isDisabled" />
                <TextElement name="selfCareInput" placeholder="điểm" input-type="number" :columns="{
                  container: 1,
                }" :disabled="isDisabled" />
              </GroupElement>
            </GroupElement>

            <StaticElement name="h2_6" tag="h4" content="MỤC TIÊU CỤ THỂ" />
            <MatrixElement name="targetTable" :input-type="{
              type: 'text',
            }" :presets="['matrix-table']" :cols="[
              {
                label: 'Mục tiêu thay đổi lối sống',
                value: 'targetLife',
              },
              {
                label: 'Kế hoạch hành động ',
                value: 'planAction',
              },
            ]" :rows="1" min="1" max="10" :disabled="isDisabled" />

          </GroupElement>

          <GroupElement name="container2_47">
            <GroupElement name="container2_48" :columns="{
              lg: {
                container: 12,
              },
            }">
              <StaticElement name="h2_4" tag="h4" content="NHẬN XÉT CHUNG
" />
              <EditorElement name="overall" :disabled="isDisabled" />

            </GroupElement>
          </GroupElement>
        </GroupElement>

      </FormElements>

      <FormStepsControls :labels="true">


      </FormStepsControls>

      <b-modal id="success-modal" ref="success-modal" title="Xác nhận hành động" size="sd" hide-footer>
        Bạn đang thay đổi thông tin khách hàng.
        <div class="w-100 d-flex align-items-center justify-content-end">
          <b-button class="btn btn-success ml-2" href="#" @click.stop="handleSuccessOk" tabindex="0"
            :disabled="isSubmitting">
            Tiếp tục
          </b-button>
          <b-button class="btn btn-plain ml-2" href="#" @click.stop="handleCancel" tabindex="0">
            Đóng
          </b-button>


        </div>
      </b-modal>

    </template>

  </Vueform>
</template>
<script>
import { DISEASES } from '@/view/pages/customer_receives/CustomerReceiveEnum';
import moment from 'moment';

export default {
  props: {
    targetItem: {
      type: Object,
      required: true,
    },
    coachList: {
      type: [Object, Array],
      required: true,
    },

  },
  computed: {
    diseasesOpts() {
      return [
        { label: 'Tiền đái tháo đường', value: DISEASES.TIEN_DAI_THAO_DUONG },
        { label: 'Đái tháo đường típ 1', value: DISEASES.DAI_THAO_DUONG_TIP_1 },
        { label: 'Đái tháo đường típ 2', value: DISEASES.DAI_THAO_DUONG_TIP_2 },
        {
          label: 'Đái tháo đường thai kì',
          value: DISEASES.DAI_THAO_DUONG_THAI_KI,
        },
        { label: 'Tăng huyết áp', value: DISEASES.TANG_HUYET_AP },
        { label: 'Béo phì', value: DISEASES.BEO_PHI },
        { label: 'Khác', value: DISEASES.KHAC },
      ];
    },

  },
  data() {
    return {
      loading: false,
      isExpandedNew: false,
      isSubmitting: false,
      isShowThongTinHanhChinh: false,
      isShowTongTrang: false,
      isShowTienSuBenh: false,
      isShowTienSuBenhXaHoi: false,
      isShowTinhThan: false,
      isShowVanDong: false,
      isShowDinhDuong: false,
      isShowDuongHuyet: false,
      isShowBanChan: false,
      isShowSuDungThuoc: false,
      isShowHocTap: false,
      isShowMuctieu: false,
      diseaseType: null,
      dataSymptom: null,
      dataSleepProblem: null,
      dataOptionChill: null,
      dataOptionReligion: null,
      dataPhysicalActivityType: null,
      dataOneDayEat: null,
      dataMedicineUsing: null,
      dataBestWayLearn: null,
      dataProlemLearn: null,
      isShowButtonUpdate: false,
      isDisabled: false,
      isEdit: false,
      formCommon: {
        formPage: {
          id: null,
          courseId: null,
          courseName: null,
          executorName: null,
          fullName: null,
          yearOfBirth: null,
          gender: null,
          phoneNumber: null,
          residence: null,
          job: null,
          diagnosedYear: null,
          knowledgePoint: null,
          knowledgeAverage: null,
          selfCarePoint: null,
          selfCareAverage: null,
          weight: null,
          height: null,
          bmi: null,
          statusTongTrang: null,
          issueTongTrang: null,
          executionDate: null,
          hypoglycemiaFrequency: null,

          // Thu set name vueform
          medicalHistoryInput: null,
          hypoglycemia: null,
          hypoglycemiaNumber: null,
          hypoglycemiaUnit: null,
          symptom: null,
          treatmentMethod: null,
          otherBenh: null,
          issueHistoryMedical: null,
          alcoholUse: null,
          frequency: null,
          amount: null,
          smokingStatus: null,
          averageCigarettesPerDay: null,
          whenMostlySmoke: null,
          livingAlone: null,
          livingWithSomeone: null,
          mainPillar: null,
          otherBenhXh: null,
          issueHistoryMedicalXh: null,
          //checkbox
          sweating: false,
          shaking: false,
          anxiety: false,
          dizziness: false,
          hunger: false,
          rapidHeartbeat: false,
          blurredVision: false,
          fatigue: false,
          headache: false,
          irritability: false,

          //checkboxTinhthan
          insomnia: false,
          poorSleepQuality: false,
          difficultyFallingAsleep: false,
          frequentWaking: false,
          useSleepingPills: false,
          sleepingProblemExpand: null,
          sleepingProblem: null,
          nightSleepingTime: null,
          middaySleepTime: null,
          totalSleepTime: null,
          //checkcondition
          problemWorry: false,
          problemStress: false,
          problemStressText: null,
          problemWorryText: null,

          //ReduceStress
          reduceStress: null,
          optRelax: false,
          optMeditation: false,
          optBreath: false,
          otherReduceStressText: null,

          //option Trust
          optTrustNo: false,
          optTrustBuddha: false,
          optTrusInChrist: false,
          optTrustIslam: false,
          otherTrustText: null,
          trustBelieve: null,

          //Workout
          // activityWorkout: false,
          activityOneWeek: null,
          activityOneWeek30min: null,
          activityWorkout: null,
          physicalActivityType: null,
          otherActivity: null,
          watchingTv: null,
          issueWorkout: null,

          //Nutrition
          oneWeekEatClean: 0,
          oneMonthEatClean: 0,
          oneWeekEatVegetable: 0,
          oneWeekEatHighProtein: 0,
          issueDinhDuong: null,
          problemFood: null,
          oneDayEat: null,
          morning: null,
          afternoon: null,
          midday: null,
          subOne: null,
          subTwo: null,
          subThree: null,

          //Habit Eating
          mainDiet: null,
          subDiet: null,
          streedFood: null,
          optstreetFood: false,
          optEatingRighttime: false,
          optEatingOutside: false,
          optEatingSugar: false,
          drinkWater: null,
          typeOfWater: null,
          kcal: null,
          ruleOfMenu: null,
          issueNutrition: null,
          otherDiet: null,
          optionProblemStress: false,
          optionProblemWorry: false,

          //Follow Glucose
          oneWeekFollowGlucose: null,
          oneWeekFollowDoctor: null,
          hba1c: null,
          hba1cDate: null,
          glucose: null,
          glucoseDate: null,
          glucoseAfter2Hours: null,
          glucoseAfter2HoursDate: null,
          otherGlucose: null,
          issueGlucose: null,
          oneWeekCheckFoot: null,
          oneWeekCheckBoost: null,
          optFootComplication: false,
          otherFootComplication: null,
          issueFoot: null,
          //MEDICINE

          optDiabetesMedications: null,
          descriptionMedicalImage: null,
          descriptionMedicalFile: null,
          medicalUsing: null,
          issueUsingMedical: null,
          otherUsingMedical: null,
          notUseMedicine: null,
          forgotMedicine: null,
          sometimeForgotMedicine: null,
          followMedicine: null,

          //LEARN
          bestOptionWayToLearn: null,
          problemLearning: null,
          otherLearning: null,
          issueLearning: null,

          listen: false,
          read: false,
          image: false,
          action: false,

          problemLanguage: false,
          problemEyes: false,
          problemEducation: false,
          problemListen: false,
          problemCulture: false,
          problemTechnology: false,

          //MOTIVATION
          motivation: null,
          problemMotivation: null,
          confidentLevel: null,
          issueMotivation: null,
          optionsHba1c: null,
          optionsWeight: null,
          optionsKnowledge: null,
          optionsKntcs: null,
          hbA1cInput: null,
          weightInput: null,
          knowledgeInput: null,
          selfCareInput: null,
          overall: null,
          targetTable: [
            {
              targetLife: null,
              planAction: null
            },
          ],

        },
      },


      editor: null,
      editor_1: null,
      genders: [
        { label: 'Nam', value: '2' },
        { label: 'Nữ', value: '1' },
      ],
    };
  },

  methods: {
    async updateSymptomString(form) {
      this.formCommon.formPage.symptom = JSON.stringify({
        sweating: form.sweating,
        shaking: form.shaking,
        anxiety: form.anxiety,
        dizziness: form.dizziness,
        hunger: form.hunger,
        rapidHeartbeat: form.rapidHeartbeat,
        blurredVision: form.blurredVision,
        fatigue: form.fatigue,
        headache: form.headache,
        irritability: form.irritability,
      });
      //  console.log("updateSymptomString", this.formCommon.formPage.symptom);
      // Only update if the value has changed
    },

    async updateSleepingProblem(form) {
      this.formCommon.formPage.sleepingProblemExpand = JSON.stringify({
        insomnia: form.insomnia,
        poorSleepQuality: form.poorSleepQuality,
        difficultyFallingAsleep: form.difficultyFallingAsleep,
        frequentWaking: form.frequentWaking,
        useSleepingPills: form.useSleepingPills,

      });

      // Only update if the value has changed
    },

    async updateOptionChill(form) {
      this.formCommon.formPage.optionChill = JSON.stringify({
        optRelax: form.optRelax,
        optMeditation: form.optMeditation,
        optBreath: form.optBreath,

      });

      // Only update if the value has changed
    },
    async updateOptionReligion(form) {
      this.formCommon.formPage.optionReligion = JSON.stringify({
        optTrustNo: form.optTrustNo,
        optTrustBuddha: form.optTrustBuddha,
        optTrusInChrist: form.optTrusInChrist,
        optTrustIslam: form.optTrustIslam,
      });

      // Only update if the value has changed
    },
    async updatePhysicalActivityType(form) {
      this.formCommon.formPage.physicalActivityType = JSON.stringify({
        yoga: form.yoga,
        swimming: form.swimming,
        walking: form.walking,
        qigong: form.qigong,
        gym: form.gym,
        cycling: form.cycling,
        running: form.running,
      });

      // Only update if the value has changed
    },
    async updateOneDayEat(form) {
      this.formCommon.formPage.oneDayEat = JSON.stringify({
        morning: form.morning,
        afternoon: form.afternoon,
        midday: form.midday,
        subOne: form.subOne,
        subTwo: form.subTwo,
        subThree: form.subThree,
      });

      // Only update if the value has changed
    },
    async updateMedicine(form) {
      this.formCommon.formPage.medicalUsing = JSON.stringify({
        notUseMedicine: form.notUseMedicine,
        forgotMedicine: form.forgotMedicine,
        sometimeForgotMedicine: form.sometimeForgotMedicine,
        followMedicine: form.followMedicine,
      });

      // Only update if the value has changed
    },
    async updateBestWayLearn(form) {
      this.formCommon.formPage.bestOptionWayToLearn = JSON.stringify({
        listen: form.listen,
        read: form.read,
        image: form.image,
        action: form.action
      });

      // Only update if the value has changed
    },
    async updateProblemLearing(form) {
      this.formCommon.formPage.problemLearning = JSON.stringify({
        problemLanguage: form.problemLanguage,
        problemEyes: form.problemEyes,
        problemEducation: form.problemEducation,
        problemListen: form.problemListen,
        problemCulture: form.problemCulture,
        problemTechnology: form.problemTechnology
      });

      // Only update if the value has changed
    },



    goToNextStep() {
      const formSteps = this.$refs.formSteps;
      if (formSteps) {
        this.collapseAll();
        //  formSteps.complete();
        formSteps.next();
      }
    },
    goToPreviousStep() {
      const form = this.$refs.formSteps$;
      this.collapseAll();
      const pageName = this.$refs.formSteps$.current$.name;
      let formSteps;
      if (pageName === 'page0') {
        formSteps = this.$refs.page0$;
      } else if (pageName === 'page1') {
        formSteps = this.$refs.page1$;
      } else if (pageName === 'page2') {
        formSteps = this.$refs.page2$;
      } else if (pageName === 'page3') {
        formSteps = this.$refs.page3$;
      }
      formSteps.select();
      form.reset();
    },


    onBeforeNextStep(step) {

      console.log('Moving to step:', step.name);


    },
    toggleAll() {
      this.isExpandedNew = !this.isExpandedNew;
      const currentPage = this.$refs.formSteps$.current$.name;
      const expanded = this.isExpandedNew;

      // Batch all state changes in one Object.assign to minimize re-renders
      const newState = {
        isShowThongTinHanhChinh: false,
        isShowTongTrang: false,
        isShowTienSuBenh: false,
        isShowTienSuBenhXaHoi: false,
        isShowTinhThan: false,
        isShowVanDong: false,
        isShowDinhDuong: false,
        isShowDuongHuyet: false,
        isShowBanChan: false,
        isShowSuDungThuoc: false,
        isShowHocTap: false,
      };

      if (currentPage === 'page0') {
        newState.isShowThongTinHanhChinh = expanded;
        newState.isShowTongTrang = expanded;
        newState.isShowTienSuBenh = expanded;
        newState.isShowTienSuBenhXaHoi = expanded;
      } else if (currentPage === 'page1') {
        newState.isShowTinhThan = expanded;
        newState.isShowVanDong = expanded;
        newState.isShowDinhDuong = expanded;
      } else if (currentPage === 'page2') {
        newState.isShowDuongHuyet = expanded;
        newState.isShowBanChan = expanded;
        newState.isShowSuDungThuoc = expanded;
        newState.isShowHocTap = expanded;
      }
      // page3: all remain false

      Object.assign(this, newState);
    },
    expandAll() {
      const currentPage = this.$refs.formSteps$.current$.name;

      // Batch all state changes
      const newState = {
        isShowThongTinHanhChinh: false,
        isShowTongTrang: false,
        isShowTienSuBenh: false,
        isShowTienSuBenhXaHoi: false,
        isShowTinhThan: false,
        isShowVanDong: false,
        isShowDinhDuong: false,
        isShowDuongHuyet: false,
        isShowBanChan: false,
        isShowSuDungThuoc: false,
        isShowHocTap: false,
      };

      if (currentPage === 'page1') {
        newState.isShowThongTinHanhChinh = true;
        newState.isShowTongTrang = true;
        newState.isShowTienSuBenh = true;
        newState.isShowTienSuBenhXaHoi = true;
      } else if (currentPage === 'page2') {
        newState.isShowTinhThan = true;
        newState.isShowVanDong = true;
        newState.isShowDinhDuong = true;
      } else if (currentPage === 'page3') {
        newState.isShowDuongHuyet = true;
        newState.isShowBanChan = true;
        newState.isShowSuDungThuoc = true;
        newState.isShowHocTap = true;
      }

      Object.assign(this, newState);
      this.isShowButtonUpdate = true;
      this.isDisabled = true;
    },
    collapseAll() {
      Object.assign(this, {
        isShowThongTinHanhChinh: false,
        isShowTongTrang: false,
        isShowTienSuBenh: false,
        isShowTienSuBenhXaHoi: false,
        isShowTinhThan: false,
        isShowVanDong: false,
        isShowDinhDuong: false,
        isShowDuongHuyet: false,
        isShowBanChan: false,
        isShowSuDungThuoc: false,
        isShowHocTap: false,
        isExpandedNew: false,
      });
    },

    toggleThongTinHanhChinh() {
      this.isShowThongTinHanhChinh = !this.isShowThongTinHanhChinh;
    },
    toggleTongTrang() {
      this.isShowTongTrang = !this.isShowTongTrang;
    },
    toggleTienSuBenh() {
      this.isShowTienSuBenh = !this.isShowTienSuBenh;
    },
    toggleTinhThan() {
      this.isShowTinhThan = !this.isShowTinhThan;
    },
    toggleVanDong() {
      this.isShowVanDong = !this.isShowVanDong;
    },
    toggleDinhDuong() {
      this.isShowDinhDuong = !this.isShowDinhDuong;
    },
    toggleDuongHuyet() {
      this.isShowDuongHuyet = !this.isShowDuongHuyet;
    },
    togglechamSocBanChan() {
      this.isShowBanChan = !this.isShowBanChan;
    },
    toggleTienSuBenhXaHoi() {
      this.isShowTienSuBenhXaHoi = !this.isShowTienSuBenhXaHoi;
    },
    toggleSuDungThuoc() {
      this.isShowSuDungThuoc = !this.isShowSuDungThuoc;
    },
    toggleHocTap() {
      this.isShowHocTap = !this.isShowHocTap;
    },
    toggleMuctieu() {
      this.isShowMuctieu = !this.isShowMuctieu;
    },
    convertDateToTimeStamp(date) {
      const convert = new Date(date);
      convert.setHours(0, 0, 0, 0); // Set time components to zero
      const executionDate = Math.floor(convert.getTime() / 1000);
      return executionDate;
    },

    async createPageOne() {

      var accountId = this.targetItem.accountId;
      if (accountId == null) {
        accountId = this.targetItem.data.accountId;
      }
      this.$store.commit('context/setLoading', true);
      if (
        this.formCommon.formPage.courseName == null ||
        this.formCommon.formPage.executorName == null ||
        this.formCommon.formPage.fullName == null ||
        this.formCommon.formPage.yearOfBirth == null ||
        this.formCommon.formPage.gender == null ||
        this.formCommon.formPage.phoneNumber == null ||
        this.formCommon.formPage.executionDate == null ||
        this.formCommon.formPage.diagnosedYear == null
      ) {

        this.goToPreviousStep();

        this.$toastr.e({
          title: 'Lỗi !',
          msg: 'Vui lòng nhập đầy đủ các trường bắt buộc',
        });
      }
      else {
        try {
          const formData = new FormData();
          formData.append('AccountId', accountId);
          formData.append('CourseName', this.formCommon.formPage.courseName);
          formData.append('ExecutorName', this.formCommon.formPage.executorName);
          formData.append('FullName', this.formCommon.formPage.fullName);
          formData.append('YearOfBirth', this.formCommon.formPage.yearOfBirth);
          formData.append('Gender', this.formCommon.formPage.gender);
          formData.append('PhoneNumber', this.formCommon.formPage.phoneNumber);
          formData.append('Residence', this.formCommon.formPage.residence);
          formData.append('Job', this.formCommon.formPage.job);
          formData.append('DiseaseType', this.formCommon.formPage.diseaseType);
          formData.append(
            'DiagnosedYear',
            this.formCommon.formPage.diagnosedYear,
          );
          formData.append(
            'KnowledgePoint',
            this.formCommon.formPage.knowledgePoint,
          );
          formData.append(
            'KnowledgeAverage',
            this.formCommon.formPage.knowledgeAverage,
          );
          formData.append(
            'SelfCarePoint',
            this.formCommon.formPage.selfCarePoint,
          );
          formData.append(
            'SelfCareAverage',
            this.formCommon.formPage.selfCareAverage,
          );
          formData.append('weight', this.formCommon.formPage.weight);
          formData.append('height', this.formCommon.formPage.height);
          formData.append('bmi', this.formCommon.formPage.bmi);
          formData.append(
            'StatusTongTrang',
            this.formCommon.formPage.statusTongTrang,
          );
          formData.append(
            'IssueTongTrang',
            this.formCommon.formPage.issueTongTrang,
          );
          formData.append(
            'ExecutionDate',
            this.convertDateToTimeStamp(this.formCommon.formPage.executionDate),
          );

          /// page 2

          formData.append('hypoglycemia', this.formCommon.formPage.hypoglycemia);
          formData.append(
            'HypoglycemiaNumber',
            this.formCommon.formPage.hypoglycemiaNumber,
          );
          formData.append(
            'HypoglycemiaUnit',
            this.formCommon.formPage.hypoglycemiaUnit,
          );
          formData.append(
            'treatmentMethod',
            this.formCommon.formPage.treatmentMethod,
          );
          formData.append(
            'IssueHistoryMedical',
            this.formCommon.formPage.issueHistoryMedical,
          );
          formData.append('alcoholUse', this.formCommon.formPage.alcoholUse);
          formData.append('frequency', this.formCommon.formPage.frequency);
          formData.append('amount', this.formCommon.formPage.amount);
          formData.append(
            'smokingStatus',
            this.formCommon.formPage.smokingStatus,
          );
          formData.append(
            'averageCigarettesPerDay',
            this.formCommon.formPage.averageCigarettesPerDay,
          );
          formData.append(
            'whenMostlySmoke',
            this.formCommon.formPage.whenMostlySmoke,
          );
          formData.append('livingAlone', this.formCommon.formPage.livingAlone);
          formData.append(
            'livingWithSomeone',
            this.formCommon.formPage.livingWithSomeone,
          );
          formData.append('mainPillar', this.formCommon.formPage.mainPillar);
          formData.append('otherBenhXh', this.formCommon.formPage.otherBenhXh);
          formData.append(
            'issueHistoryMedicalXh',
            this.formCommon.formPage.issueHistoryMedicalXh,
          );
          formData.append(
            'medicalHistoryInput',
            this.formCommon.formPage.medicalHistoryInput,
          );

          if (this.dataSymptom) {
            await this.updateSymptomString(this.dataSymptom);
          }
          formData.append('symptom', this.formCommon.formPage.symptom);
          await this.$api.post('/DsmesInformation', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });

          // Handle successful response
          this.$toastr.s({
            title: 'Thành công!',
            msg: 'Thông tin đã được thêm thành công.',
          });
        } catch (error) {
          this.$toastr.e({
            title: 'Lỗi!',
            msg: error.message || 'Đã xảy ra lỗi.',
          });
        } finally {
          this.$store.commit('context/setLoading', false);
          this.isShowButtonUpdate = false;
          this.isDisabled = false;
          this.collapseAll();
        }
      }


    },
    async createPageTwo() {
      var accountId = this.targetItem.accountId;
      if (accountId == null) {
        accountId = this.targetItem.data.accountId;
      }
      this.$store.commit('context/setLoading', true);
      try {

        const formData = new FormData();
        formData.append('AccountId', accountId);
        formData.append('SleepingProblem', this.formCommon.formPage.sleepingProblem);
        await this.updateSleepingProblem(this.dataSleepProblem);
        formData.append('SleepingExpand', this.formCommon.formPage.sleepingProblemExpand);
        formData.append('NightSleepingTime', this.formCommon.formPage.nightSleepingTime);
        formData.append('MiddaySleepTime', this.formCommon.formPage.middaySleepTime);
        formData.append('TotalSleepTime', this.formCommon.formPage.totalSleepTime);
        formData.append('optionProblemWorry', this.formCommon.formPage.optionProblemWorry);
        formData.append('ProblemWorry', this.formCommon.formPage.problemWorryText);
        formData.append('optionProblemStress', this.formCommon.formPage.optionProblemStress);
        formData.append('ProblemStress', this.formCommon.formPage.problemStressText);
        await this.updateOptionChill(this.dataOptionChill);
        formData.append('OptionChill', this.formCommon.formPage.optionChill);
        formData.append('OtherReduceStress', this.formCommon.formPage.otherReduceStressText);
        await this.updateOptionReligion(this.dataOptionReligion);
        formData.append('OptionReligion', this.formCommon.formPage.optionReligion);
        formData.append('otherSpirit', this.formCommon.formPage.otherSpirit);
        await this.updatePhysicalActivityType(this.dataPhysicalActivityType);
        formData.append('PhysicalActivityType', this.formCommon.formPage.physicalActivityType);
        formData.append('OtherActivity', this.formCommon.formPage.otherActivity);
        formData.append('IssueWorkout', this.formCommon.formPage.issueWorkout);
        formData.append('oneWeekEatClean', this.formCommon.formPage.oneWeekEatClean);
        formData.append('oneMonthEatClean', this.formCommon.formPage.oneMonthEatClean);
        formData.append('oneWeekEatVegetable', this.formCommon.formPage.oneWeekEatVegetable);
        formData.append('oneWeekEatHighProtein', this.formCommon.formPage.oneWeekEatHighProtein);
        formData.append('ProblemFood', this.formCommon.formPage.problemFood);
        await this.updateOneDayEat(this.dataOneDayEat);
        formData.append('OneDayEat', this.formCommon.formPage.oneDayEat);

        formData.append('mainDiet', this.formCommon.formPage.mainDiet);
        formData.append('subDiet', this.formCommon.formPage.subDiet);
        formData.append('StreetFood', this.formCommon.formPage.optstreetFood);
        formData.append('optEatingOutside', this.formCommon.formPage.optEatingOutside);
        formData.append('optEatingSugar', this.formCommon.formPage.optEatingSugar);
        formData.append('optEatingRighttime', this.formCommon.formPage.optEatingRighttime);
        formData.append('drinkWater', this.formCommon.formPage.drinkWater);
        formData.append('typeOfWater', this.formCommon.formPage.typeOfWater);
        formData.append('kcal', this.formCommon.formPage.kcal);
        formData.append('ruleOfMenu', this.formCommon.formPage.ruleOfMenu);
        formData.append('issueNutrition', this.formCommon.formPage.issueNutrition);
        formData.append('otherDiet', this.formCommon.formPage.otherDiet);
        formData.append('activityOneWeek30min', this.formCommon.formPage.activityOneWeek30min);

        // Make API call
        await this.$api.post('/DsmesActivityNutrition', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        // Handle successful response
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Thông tin đã được thêm thành công.',
        });
      } catch (error) {
        console.log("warning", error);
      } finally {
        this.$store.commit('context/setLoading', false);
        this.isShowButtonUpdate = false;

        this.collapseAll();
      }

    },

    async createPageThree() {
      console.log(this.$refs.formSteps$.current$.name);

      var accountId = this.targetItem.accountId;
      if (accountId == null) {
        accountId = this.targetItem.data.accountId;
      }
      this.$store.commit('context/setLoading', true);
      try {

        const formData = new FormData();
        formData.append('AccountId', accountId);
        formData.append('oneWeekFollowGlucose', this.formCommon.formPage.oneWeekFollowGlucose);
        formData.append('oneWeekFollowDoctor', this.formCommon.formPage.oneWeekFollowDoctor);
        formData.append('hba1c', this.formCommon.formPage.hba1c);
        formData.append('hba1cDate', this.convertDateToTimeStamp(this.formCommon.formPage.hba1cDate));
        formData.append('glucose', this.formCommon.formPage.glucose);
        formData.append('glucoseDate', this.convertDateToTimeStamp(this.formCommon.formPage.glucoseDate));
        formData.append('glucoseAfter2Hours', this.formCommon.formPage.glucoseAfter2Hours);
        formData.append('glucoseAfter2HoursDate', this.convertDateToTimeStamp(this.formCommon.formPage.glucoseAfter2HoursDate));
        formData.append('otherGlucose', this.formCommon.formPage.otherGlucose);
        formData.append('issueGlucose', this.formCommon.formPage.issueGlucose);
        formData.append('oneWeekCheckFoot', this.formCommon.formPage.oneWeekCheckFoot);
        formData.append('oneWeekCheckBoost', this.formCommon.formPage.oneWeekCheckBoost);
        formData.append('optFootComplication', this.formCommon.formPage.optFootComplication);
        formData.append('otherFootComplication', this.formCommon.formPage.otherFootComplication);
        formData.append('issueFoot', this.formCommon.formPage.issueFoot);
        formData.append('optDiabetesMedications', this.formCommon.formPage.optDiabetesMedications);
        let images = [];
        for (let i = 0; i < this.formCommon.formPage.descriptionMedicalImage.length; i++) {
          try {
            var image = await this.uploadFileHandler(this.formCommon.formPage.descriptionMedicalImage[i])
            images.push({ url: image });
          } catch (error) {
            this.$toastr.e({
              title: 'Lỗi !',
              msg: error.message || 'Có lỗi xảy ra khi upload hình ảnh',
            });
            return;
          }
        }

        formData.append('descriptionMedicalImage', JSON.stringify(images));

        let files = [];
        for (let i = 0; i < this.formCommon.formPage.descriptionMedicalFile.length; i++) {
          try {
            var file = await this.uploadFileHandler(this.formCommon.formPage.descriptionMedicalFile[i])
            files.push({ url: file });
          } catch (error) {
            this.$toastr.e({
              title: 'Lỗi !',
              msg: error.message || 'Có lỗi xảy ra khi upload file',
            });
            return;
          }
        }

        formData.append('descriptionMedicalFile', JSON.stringify(files));

        await this.updateMedicine(this.dataMedicineUsing);
        formData.append('medicalUsing', this.formCommon.formPage.medicalUsing);
        formData.append('issueUsingMedical', this.formCommon.formPage.issueUsingMedical);
        formData.append('otherUsingMedical', this.formCommon.formPage.otherUsingMedical);
        formData.append('issueUsingMedical', this.formCommon.formPage.issueUsingMedical);

        await this.updateBestWayLearn(this.dataBestWayLearn);
        formData.append('bestOptionWayToLearn', this.formCommon.formPage.bestOptionWayToLearn);
        await this.updateProblemLearing(this.dataProlemLearn);
        formData.append('problemLearning', this.formCommon.formPage.problemLearning);
        formData.append('otherLearning', this.formCommon.formPage.otherLearning);
        formData.append('issueLearning', this.formCommon.formPage.issueLearning);

        // Make API call
        await this.$api.post('/DsmesSelfCare', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        // Handle successful response
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Thông tin đã được thêm thành công.',
        });
      } catch (error) {
        console.log("warning", error);
      } finally {
        this.$store.commit('context/setLoading', false);
        this.isShowButtonUpdate = false;
        this.collapseAll();

        //    this.goToNextStep();
      }

    },

    async createPageFour() {
      this.$store.commit('context/setLoading', true);
      var accountId = this.targetItem.accountId;
      if (accountId == null) {
        accountId = this.targetItem.data.accountId;
      }
      try {
        const formData = new FormData();
        formData.append('AccountId', accountId);
        formData.append('motivation', this.formCommon.formPage.motivation);
        formData.append('problemMotivation', this.formCommon.formPage.problemMotivation);
        formData.append('confidentLevel', this.formCommon.formPage.confidentLevel);
        formData.append('issueMotivation', this.formCommon.formPage.issueMotivation);
        formData.append('targetHba1c', this.formCommon.formPage.optionsHba1c);
        formData.append('hba1c', this.formCommon.formPage.hbA1cInput);
        formData.append('targetWeight', this.formCommon.formPage.optionsWeight);
        formData.append('weight', this.formCommon.formPage.weightInput);
        formData.append('targetKnowledge', this.formCommon.formPage.optionsKnowledge);
        formData.append('knowledge', this.formCommon.formPage.knowledgeInput);
        formData.append('targetSelfcare', this.formCommon.formPage.optionsKntcs);
        formData.append('selfCare', this.formCommon.formPage.selfCareInput);
        formData.append('overall', this.formCommon.formPage.overall);
        formData.append('targetTable', JSON.stringify(this.formCommon.formPage.targetTable));


        // Make API call
        await this.$api.post('/DsmesMotivation', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        // Handle successful response
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Thông tin đã được thêm thành công.',
        });
      } catch (error) {
        console.log("warning", error);
      } finally {
        this.isShowButtonUpdate = false;
        this.closeParentModal()
        this.$store.commit('context/setLoading', false);

      }

    },

    closeParentModal() {
      this.$emit('closeModal');
    },

    findCoachName(id) {
      const coach = this.coachList.find((coach) => coach.value === id);
      return coach.text
    },

    setupPage0() {
      this.$refs.page0$.complete();
      this.$refs.page0$.enable();

      this.$refs.vueform$.update({
        fullName: this.targetItem.data.information.fullName,
        phoneNumber: this.targetItem.data.information.phoneNumber,
        yearOfBirth: this.targetItem.data.information.yearOfBirth,
        diseaseType: this.targetItem.data.information.diseaseType,
        gender: this.targetItem.data.information.gender,
        courseName: this.targetItem.data.information.courseName,
        executorName: this.targetItem.data.information.executorName,
        residence: this.targetItem.data.information.residence,
        job: this.targetItem.data.information.job,
        diagnosedYear: this.targetItem.data.information.diagnosedYear,
        knowledgePoint: this.targetItem.data.information.knowledgePoint,
        knowledgeAverage: this.targetItem.data.information.knowledgeAverage,
        selfCarePoint: this.targetItem.data.information.selfCarePoint,
        selfCareAverage: this.targetItem.data.information.selfCareAverage,
        weight: this.targetItem.data.information.weight,
        height: this.targetItem.data.information.height,
        bmi: this.targetItem.data.information.bmi,
        statusTongTrang: this.targetItem.data.information.statusTongTrang,
        issueTongTrang: this.targetItem.data.information.issueTongTrang,
        executionDate: moment(this.targetItem.data.information.executionDate * 1000).format('YYYY-MM-DD'),
        hypoglycemiaFrequency: this.targetItem.data.medicalHistory.hypoglycemiaFrequency,
        medicalHistoryInput: this.targetItem.data.medicalHistory.medicalHistoryInput,
        hypoglycemia: this.targetItem.data.medicalHistory.hypoglycemia,
        hypoglycemiaNumber: this.targetItem.data.medicalHistory.hypoglycemiaNumber,
        hypoglycemiaUnit: this.targetItem.data.medicalHistory.hypoglycemiaUnit,
        sweating: JSON.parse(this.targetItem.data.medicalHistory.symptom)?.sweating || false,
        dizziness: JSON.parse(this.targetItem.data.medicalHistory.symptom)?.dizziness || false,
        shaking: JSON.parse(this.targetItem.data.medicalHistory.symptom)?.shaking || false,
        anxiety: JSON.parse(this.targetItem.data.medicalHistory.symptom)?.anxiety || false,
        hunger: JSON.parse(this.targetItem.data.medicalHistory.symptom)?.hunger || false,
        rapidHeartbeat: JSON.parse(this.targetItem.data.medicalHistory.symptom)?.rapidHeartbeat || false,
        blurredVision: JSON.parse(this.targetItem.data.medicalHistory.symptom)?.blurredVision || false,
        fatigue: JSON.parse(this.targetItem.data.medicalHistory.symptom)?.fatigue || false,
        headache: JSON.parse(this.targetItem.data.medicalHistory.symptom)?.headache || false,
        irritability: JSON.parse(this.targetItem.data.medicalHistory.symptom)?.irritability || false,
        treatmentMethod: this.targetItem.data.medicalHistory.treatmentMethod,
        otherBenh: this.targetItem.data.medicalHistory.otherBenh,
        issueHistoryMedical: this.targetItem.data.medicalHistory.issueHistoryMedical,
        alcoholUse: this.targetItem.data.medicalHistory.alcoholUse,
        frequency: this.targetItem.data.medicalHistory.frequency,
        amount: this.targetItem.data.medicalHistory.amount,
        smokingStatus: this.targetItem.data.medicalHistory.smokingStatus,
        averageCigarettesPerDay: this.targetItem.data.medicalHistory.averageCigarettesPerDay,
        whenMostlySmoke: this.targetItem.data.medicalHistory.whenMostlySmoke,
        livingAlone: this.targetItem.data.medicalHistory.livingAlone,
        livingWithSomeone: this.targetItem.data.medicalHistory.livingWithSomeone,
        mainPillar: this.targetItem.data.medicalHistory.mainPillar,
        otherBenhXh: this.targetItem.data.medicalHistory.otherBenhXh,
      })

    },



    setupPage1() {
      this.$refs.page1$.complete();
      this.$refs.page1$.enable();

      this.$refs.vueform$.update({
        sleepingProblem: this.targetItem.data.activityNutrition.sleepingProblem,

        insomnia: JSON.parse(this.targetItem.data.activityNutrition.sleepingExpand)?.insomnia || false,
        poorSleepQuality: JSON.parse(this.targetItem.data.activityNutrition.sleepingExpand)?.poorSleepQuality || false,
        difficultyFallingAsleep: JSON.parse(this.targetItem.data.activityNutrition.sleepingExpand)?.difficultyFallingAsleep || false,
        frequentWaking: JSON.parse(this.targetItem.data.activityNutrition.sleepingExpand)?.frequentWaking || false,
        useSleepingPills: JSON.parse(this.targetItem.data.activityNutrition.sleepingExpand)?.useSleepingPills || false,

        nightSleepingTime: this.targetItem.data.activityNutrition.nightSleepingTime,
        middaySleepTime: this.targetItem.data.activityNutrition.middaySleepTime,
        totalSleepTime: this.targetItem.data.activityNutrition.totalSleepTime,
        optionProblemWorry: this.targetItem.data.activityNutrition.optionProblemWorry,
        problemWorryText: this.targetItem.data.activityNutrition.problemWorryText,
        optionProblemStress: this.targetItem.data.activityNutrition.optionProblemStress,
        problemStressText: this.targetItem.data.activityNutrition.problemStressText,

        optRelax: JSON.parse(this.targetItem.data.activityNutrition.optionChill)?.optRelax || false,
        optMeditation: JSON.parse(this.targetItem.data.activityNutrition.optionChill)?.optMeditation || false,
        optBreath: JSON.parse(this.targetItem.data.activityNutrition.optionChill)?.optBreath || false,
        otherReduceStressText: this.targetItem.data.activityNutrition.otherReduceStress,

        optTrustNo: JSON.parse(this.targetItem.data.activityNutrition.optionReligion)?.optTrustNo || false,
        optTrustBuddha: JSON.parse(this.targetItem.data.activityNutrition.optionReligion)?.optTrustBuddha || false,
        optTrusInChrist: JSON.parse(this.targetItem.data.activityNutrition.optionReligion)?.optTrusInChrist || false,
        optTrustIslam: JSON.parse(this.targetItem.data.activityNutrition.optionReligion)?.optTrustIslam || false,
        otherTrustText: this.targetItem.data.activityNutrition.otherTrustText,
        otherReligionText: this.targetItem.data.activityNutrition.otherReligion,

        issueTinhThan: this.targetItem.data.activityNutrition.issueTinhThan,
        activityOneWeek: this.targetItem.data.activityNutrition.activityOneWeek,
        activityOneWeek30min: this.targetItem.data.activityNutrition.activityOneWeek30min,
        activityWorkout: this.targetItem.data.activityNutrition.activityWorkout,

        yoga: JSON.parse(this.targetItem.data.activityNutrition.physicalActivityType)?.yoga || false,
        swimming: JSON.parse(this.targetItem.data.activityNutrition.physicalActivityType)?.swimming || false,
        qigong: JSON.parse(this.targetItem.data.activityNutrition.physicalActivityType)?.qigong || false,
        walking: JSON.parse(this.targetItem.data.activityNutrition.physicalActivityType)?.yoga || false,
        gym: JSON.parse(this.targetItem.data.activityNutrition.physicalActivityType)?.gym || false,
        cycling: JSON.parse(this.targetItem.data.activityNutrition.physicalActivityType)?.cycling || false,
        running: JSON.parse(this.targetItem.data.activityNutrition.physicalActivityType)?.running || false,
        otherPhysicalActivity: this.targetItem.data.activityNutrition.otherPhysicalActivity,
        otherActivity: this.targetItem.data.activityNutrition.otherActivity,

        oneWeekEatClean: this.targetItem.data.activityNutrition.oneWeekEatClean,
        oneMonthEatClean: this.targetItem.data.activityNutrition.oneMonthEatClean,
        oneWeekEatVegetable: this.targetItem.data.activityNutrition.oneWeekEatVegetable,
        oneWeekEatHighProtein: this.targetItem.data.activityNutrition.oneWeekEatHighProtein,

        problemFood: this.targetItem.data.activityNutrition.problemFood,
        morning: JSON.parse(this.targetItem.data.activityNutrition.oneDayEat)?.morning || false,
        subOne: JSON.parse(this.targetItem.data.activityNutrition.oneDayEat)?.subOne || false,
        midday: JSON.parse(this.targetItem.data.activityNutrition.oneDayEat)?.midday || false,
        subTwo: JSON.parse(this.targetItem.data.activityNutrition.oneDayEat)?.subTwo || false,
        afternoon: JSON.parse(this.targetItem.data.activityNutrition.oneDayEat)?.afternoon || false,
        subThree: JSON.parse(this.targetItem.data.activityNutrition.oneDayEat)?.subThree || false,
        mainDiet: this.targetItem.data.activityNutrition.mainDiet,
        subDiet: this.targetItem.data.activityNutrition.subDiet,
        optstreetFood: this.targetItem.data.activityNutrition.optstreetFood,
        streetFood: this.targetItem.data.activityNutrition.streetFood,
        optEatingRighttime: this.targetItem.data.activityNutrition.optEatingRighttime,
        optEatingOutside: this.targetItem.data.activityNutrition.optEatingOutside,
        optEatingSugar: this.targetItem.data.activityNutrition.optEatingSugar,
        drinkWater: this.targetItem.data.activityNutrition.drinkWater,
        typeOfWater: this.targetItem.data.activityNutrition.typeOfWater,
        kcal: this.targetItem.data.activityNutrition.kcal,
        ruleOfMenu: this.targetItem.data.activityNutrition.ruleOfMenu,
        otherDiet: this.targetItem.data.activityNutrition.otherDiet,
        issueNutrion: this.targetItem.data.activityNutrition.issueNutrion,
      })
    },

    setupPage2() {
      this.$refs.page2$.complete();
      this.$refs.page2$.enable();

      this.$refs.vueform$.update({
        oneWeekFollowGlucose: this.targetItem.data.selfCare.oneWeekFollowGlucose,
        oneWeekFollowDoctor: this.targetItem.data.selfCare.oneWeekFollowDoctor,
        hba1c: this.targetItem.data.selfCare.hba1c,
        hba1cDate: moment(this.targetItem.data.selfCare.hba1cDate * 1000).format('YYYY-MM-DD'),
        glucose: this.targetItem.data.selfCare.glucose,
        glucoseDate: moment(this.targetItem.data.selfCare.glucoseDate * 1000).format('YYYY-MM-DD'),
        glucoseAfter2Hours: this.targetItem.data.selfCare.glucoseAfter2Hours,
        glucoseAfter2HoursDate: moment(this.targetItem.data.selfCare.glucoseAfter2HoursDate * 1000).format('YYYY-MM-DD'),
        otherGlucose: this.targetItem.data.selfCare.otherGlucose,
        issueGlucose: this.targetItem.data.selfCare.issueGlucose,

        oneWeekCheckFoot: this.targetItem.data.selfCare.oneWeekCheckFoot,
        oneWeekCheckBoost: this.targetItem.data.selfCare.oneWeekCheckBoost,
        optFootComplication: this.targetItem.data.selfCare.optFootComplication,
        otherFootComplication: this.targetItem.data.selfCare.otherFootComplication,
        issueFoot: this.targetItem.data.selfCare.issueFoot,

        optDiabetesMedications: this.targetItem.data.selfCare.optDiabetesMedications,
        // fileImage : JSON.parse(this.targetItem.data.selfCare.descriptionMedicalImage),
        // fileFile : JSON.parse(this.targetItem.data.selfCare.descriptionMedicalFile),

        notUseMedicine: JSON.parse(this.targetItem.data.selfCare.medicalUsing)?.notUseMedicine || false,
        forgotMedicine: JSON.parse(this.targetItem.data.selfCare.medicalUsing)?.forgotMedicine || false,
        sometimeForgotMedicine: JSON.parse(this.targetItem.data.selfCare.medicalUsing)?.sometimeForgotMedicine || false,
        followMedicine: JSON.parse(this.targetItem.data.selfCare.medicalUsing)?.followMedicine || false,
        otherUsingMedical: this.targetItem.data.selfCare.otherUsingMedical,
        issueUsingMedical: this.targetItem.data.selfCare.issueUsingMedical,

        listen: JSON.parse(this.targetItem.data.selfCare.bestOptionWayToLearn)?.listen || false,
        read: JSON.parse(this.targetItem.data.selfCare.bestOptionWayToLearn)?.read || false,
        image: JSON.parse(this.targetItem.data.selfCare.bestOptionWayToLearn)?.image || false,
        action: JSON.parse(this.targetItem.data.selfCare.bestOptionWayToLearn)?.action || false,

        problemLanguage: JSON.parse(this.targetItem.data.selfCare.problemLearning)?.problemLanguage || false,
        problemEyes: JSON.parse(this.targetItem.data.selfCare.problemLearning)?.problemEyes || false,
        problemEducation: JSON.parse(this.targetItem.data.selfCare.problemLearning)?.problemEducation || false,
        problemListen: JSON.parse(this.targetItem.data.selfCare.problemLearning)?.problemListen || false,
        problemCulture: JSON.parse(this.targetItem.data.selfCare.problemLearning)?.problemCulture || false,
        problemTechnology: JSON.parse(this.targetItem.data.selfCare.problemLearning)?.problemTechnology || false,
        otherLearning: this.targetItem.data.selfCare.otherLearning,
        issueLearning: this.targetItem.data.selfCare.issueLearning,

      })


    },
    setupPage3() {
      this.$refs.page3$.complete();
      this.$refs.page3$.enable();
      this.$refs.vueform$.update({
        motivation: this.targetItem.data.motivation.motivation,
        problemMotivation: this.targetItem.data.motivation.problemMotivation,
        confidentLevel: this.targetItem.data.motivation.confidentLevel,
        issueMotivation: this.targetItem.data.motivation.issueMotivation,
        optionsHba1c: this.targetItem.data.motivation.targetHba1c,
        hbA1cInput: this.targetItem.data.motivation.hba1c,
        optionsWeight: this.targetItem.data.motivation.targetWeight,
        weightInput: this.targetItem.data.motivation.weight,
        optionsKnowledge: this.targetItem.data.motivation.targetKnowledge,
        knowledgeInput: this.targetItem.data.motivation.knowledge,
        optionsKntcs: this.targetItem.data.motivation.targetSelfcare,
        selfCareInput: this.targetItem.data.motivation.selfcare,
        targetTable: JSON.parse(this.targetItem.data.motivation.targetTable),
        overall: this.targetItem.data.motivation.overall,
      })
    },




    async setupData() {
      if (this.targetItem.name != null) {
        this.$refs.vueform$.update({
          fullName: this.targetItem.name,
          phoneNumber: this.targetItem.phoneNumber,
          yearOfBirth: this.targetItem.birthYear,
          diseaseType: this.targetItem.diseaseType,
          gender: this.targetItem.gender,
          courseName: "OnBoarding",
          executorName: this.findCoachName(this.targetItem.coachId),
          executionDate: new Date().toISOString().substr(0, 10),
        })
      }
      else {
        this.setupPage0();
        const pagesToSetup = [
          { step: 1, setup: this.setupPage1 },
          { step: 2, setup: () => { this.setupPage1(); this.setupPage2(); } },
          { step: 3, setup: () => { this.setupPage1(); this.setupPage2(); this.setupPage3(); } }
        ];
        const currentPage = pagesToSetup.find(page => page.step === this.targetItem.data.formStep);
        if (currentPage) {
          currentPage.setup();
        }
        this.isDisabled = true;
      }
    },

    async uploadFileHandler(file) {
      if (!file) {
        console.log("No file selected.");
        return;
      }

      try {
        const result = await this.$store.dispatch('context/UPLOAD_FILE', file);
        if (result.error) {
          console.error("Upload failed:", result.error);
        } else {
          console.log("Upload successful:", result.data);
          return result.data;

        }
      } catch (error) {
        console.error("An error occurred:", error);
      }

    },

    async editBtn() {
      this.isDisabled = false;
      this.isEdit = true;
    },

    async updateBtn() {
      this.$refs['success-modal'].show();

    },
    async cancelBtn() {
      this.isDisabled = true;
      this.isEdit = false;

    },

    handleCancel() {
      this.$refs['success-modal'].hide();
      this.isEdit = false;
    },
    async handleSuccessOk() {
      const pageName = this.$refs.formSteps$.current$.name;
      if (pageName === 'page0') {

        await this.createPageOne();
      } else if (pageName === 'page1') {
        await this.createPageTwo();
      } else if (pageName === 'page2') {
        await this.createPageThree();
      } else if (pageName === 'page3') {
        await this.createPageFour();
      }
      //  formSteps.select();
      //  formSteps.uncomplete();
      this.isEdit = false;
      this.$refs['success-modal'].hide();

    },
    openImage() {

      const file = JSON.parse(this.targetItem.data.selfCare.descriptionMedicalFile)[0];
      if (file) {
        window.open(file.url, '_blank');
      }
    },

    openFile() {

      const file = JSON.parse(this.targetItem.data.selfCare.descriptionMedicalImage)[0];
      if (file) {
        window.open(file.url, '_blank');
      }
    }




  },
  watch: {
    // NOTE: deep watcher removed to fix UI lag
  },
  created() {
    // Set data references once - no watcher needed since they reference the same object
    const fp = this.formCommon.formPage;
    this.dataSymptom = fp;
    this.dataSleepProblem = fp;
    this.dataOptionChill = fp;
    this.dataOptionReligion = fp;
    this.dataPhysicalActivityType = fp;
    this.dataOneDayEat = fp;
    this.dataMedicineUsing = fp;
    this.dataBestWayLearn = fp;
    this.dataProlemLearn = fp;
  },
  beforeDestroy() {
    // Clean up references to help garbage collection
    this.dataSymptom = null;
    this.dataSleepProblem = null;
    this.dataOptionChill = null;
    this.dataOptionReligion = null;
    this.dataPhysicalActivityType = null;
    this.dataOneDayEat = null;
    this.dataMedicineUsing = null;
    this.dataBestWayLearn = null;
    this.dataProlemLearn = null;
  },
  mounted() {
    this.setupData();
  },

};
</script>

<style>
.vf-coach-comment *,
.vf-coach-comment *:before,
.vf-coach-comment *:after,
.vf-coach-comment:root {
  --vf-primary: #07bf9b;
  --vf-primary-darker: #06ac8b;
  --vf-color-on-primary: #ffffff;
  --vf-danger: #ef4444;
  --vf-danger-lighter: #fee2e2;
  --vf-success: #10b981;
  --vf-success-lighter: #d1fae5;
  --vf-gray-50: #f9fafb;
  --vf-gray-100: #f3f4f6;
  --vf-gray-200: #e5e7eb;
  --vf-gray-300: #d1d5db;
  --vf-gray-400: #9ca3af;
  --vf-gray-500: #6b7280;
  --vf-gray-600: #4b5563;
  --vf-gray-700: #374151;
  --vf-gray-800: #1f2937;
  --vf-gray-900: #111827;
  --vf-dark-50: #efefef;
  --vf-dark-100: #dcdcdc;
  --vf-dark-200: #bdbdbd;
  --vf-dark-300: #a0a0a0;
  --vf-dark-400: #848484;
  --vf-dark-500: #737373;
  --vf-dark-600: #393939;
  --vf-dark-700: #323232;
  --vf-dark-800: #262626;
  --vf-dark-900: #191919;
  --vf-ring-width: 2px;
  --vf-ring-color: #07bf9b66;
  --vf-link-color: var(--vf-primary);
  --vf-link-decoration: inherit;
  --vf-font-size: 1rem;
  --vf-font-size-sm: 0.875rem;
  --vf-font-size-lg: 1rem;
  --vf-font-size-small: 0.875rem;
  --vf-font-size-small-sm: 0.8125rem;
  --vf-font-size-small-lg: 0.875rem;
  --vf-font-size-h1: 2.125rem;
  --vf-font-size-h1-sm: 2.125rem;
  --vf-font-size-h1-lg: 2.125rem;
  --vf-font-size-h2: 1.875rem;
  --vf-font-size-h2-sm: 1.875rem;
  --vf-font-size-h2-lg: 1.875rem;
  --vf-font-size-h3: 1.5rem;
  --vf-font-size-h3-sm: 1.5rem;
  --vf-font-size-h3-lg: 1.5rem;
  --vf-font-size-h4: 1.25rem;
  --vf-font-size-h4-sm: 1.25rem;
  --vf-font-size-h4-lg: 1.25rem;
  --vf-font-size-h1-mobile: 1.5rem;
  --vf-font-size-h1-mobile-sm: 1.5rem;
  --vf-font-size-h1-mobile-lg: 1.5rem;
  --vf-font-size-h2-mobile: 1.25rem;
  --vf-font-size-h2-mobile-sm: 1.25rem;
  --vf-font-size-h2-mobile-lg: 1.25rem;
  --vf-font-size-h3-mobile: 1.125rem;
  --vf-font-size-h3-mobile-sm: 1.125rem;
  --vf-font-size-h3-mobile-lg: 1.125rem;
  --vf-font-size-h4-mobile: 1rem;
  --vf-font-size-h4-mobile-sm: 1rem;
  --vf-font-size-h4-mobile-lg: 1rem;
  --vf-font-size-blockquote: 1rem;
  --vf-font-size-blockquote-sm: 0.875rem;
  --vf-font-size-blockquote-lg: 1rem;
  --vf-line-height: 1.5rem;
  --vf-line-height-sm: 1.25rem;
  --vf-line-height-lg: 1.5rem;
  --vf-line-height-small: 1.25rem;
  --vf-line-height-small-sm: 1.125rem;
  --vf-line-height-small-lg: 1.25rem;
  --vf-line-height-headings: 1.2;
  --vf-line-height-headings-sm: 1.2;
  --vf-line-height-headings-lg: 1.2;
  --vf-line-height-blockquote: 1.5rem;
  --vf-line-height-blockquote-sm: 1.25rem;
  --vf-line-height-blockquote-lg: 1.5rem;
  --vf-letter-spacing: 0px;
  --vf-letter-spacing-sm: 0px;
  --vf-letter-spacing-lg: 0px;
  --vf-letter-spacing-small: 0px;
  --vf-letter-spacing-small-sm: 0px;
  --vf-letter-spacing-small-lg: 0px;
  --vf-letter-spacing-headings: 0px;
  --vf-letter-spacing-headings-sm: 0px;
  --vf-letter-spacing-headings-lg: 0px;
  --vf-letter-spacing-blockquote: 0px;
  --vf-letter-spacing-blockquote-sm: 0px;
  --vf-letter-spacing-blockquote-lg: 0px;
  --vf-gutter: 1rem;
  --vf-gutter-sm: 0.5rem;
  --vf-gutter-lg: 1rem;
  --vf-min-height-input: 2.375rem;
  --vf-min-height-input-sm: 2.125rem;
  --vf-min-height-input-lg: 2.875rem;
  --vf-py-input: 0.375rem;
  --vf-py-input-sm: 0.375rem;
  --vf-py-input-lg: 0.625rem;
  --vf-px-input: 0.75rem;
  --vf-px-input-sm: 0.5rem;
  --vf-px-input-lg: 0.875rem;
  --vf-py-btn: 0.375rem;
  --vf-py-btn-sm: 0.375rem;
  --vf-py-btn-lg: 0.625rem;
  --vf-px-btn: 0.875rem;
  --vf-px-btn-sm: 0.75rem;
  --vf-px-btn-lg: 1.25rem;
  --vf-py-btn-small: 0.25rem;
  --vf-py-btn-small-sm: 0.25rem;
  --vf-py-btn-small-lg: 0.375rem;
  --vf-px-btn-small: 0.625rem;
  --vf-px-btn-small-sm: 0.625rem;
  --vf-px-btn-small-lg: 0.75rem;
  --vf-py-group-tabs: 0.375rem;
  --vf-py-group-tabs-sm: 0.375rem;
  --vf-py-group-tabs-lg: 0.625rem;
  --vf-px-group-tabs: 0.75rem;
  --vf-px-group-tabs-sm: 0.5rem;
  --vf-px-group-tabs-lg: 0.875rem;
  --vf-py-group-blocks: 0.75rem;
  --vf-py-group-blocks-sm: 0.625rem;
  --vf-py-group-blocks-lg: 0.875rem;
  --vf-px-group-blocks: 1rem;
  --vf-px-group-blocks-sm: 1rem;
  --vf-px-group-blocks-lg: 1rem;
  --vf-py-tag: 0px;
  --vf-py-tag-sm: 0px;
  --vf-py-tag-lg: 0px;
  --vf-px-tag: 0.4375rem;
  --vf-px-tag-sm: 0.4375rem;
  --vf-px-tag-lg: 0.4375rem;
  --vf-py-slider-tooltip: 0.125rem;
  --vf-py-slider-tooltip-sm: 0.0625rem;
  --vf-py-slider-tooltip-lg: 0.1875rem;
  --vf-px-slider-tooltip: 0.375rem;
  --vf-px-slider-tooltip-sm: 0.3125rem;
  --vf-px-slider-tooltip-lg: 0.5rem;
  --vf-py-blockquote: 0.25rem;
  --vf-py-blockquote-sm: 0.25rem;
  --vf-py-blockquote-lg: 0.25rem;
  --vf-px-blockquote: 0.75rem;
  --vf-px-blockquote-sm: 0.75rem;
  --vf-px-blockquote-lg: 0.75rem;
  --vf-py-hr: 0.25rem;
  --vf-space-addon: 0px;
  --vf-space-addon-sm: 0px;
  --vf-space-addon-lg: 0px;
  --vf-space-checkbox: 0.375rem;
  --vf-space-checkbox-sm: 0.375rem;
  --vf-space-checkbox-lg: 0.375rem;
  --vf-space-tags: 0.1875rem;
  --vf-space-tags-sm: 0.1875rem;
  --vf-space-tags-lg: 0.1875rem;
  --vf-space-static-tag-1: 1rem;
  --vf-space-static-tag-2: 2rem;
  --vf-space-static-tag-3: 3rem;
  --vf-floating-top: 0rem;
  --vf-floating-top-sm: 0rem;
  --vf-floating-top-lg: 0.6875rem;
  --vf-bg-input: #ffffff;
  --vf-bg-input-hover: #ffffff;
  --vf-bg-input-focus: #ffffff;
  --vf-bg-input-danger: #ffffff;
  --vf-bg-input-success: #ffffff;
  --vf-bg-checkbox: #ffffff;
  --vf-bg-checkbox-hover: #ffffff;
  --vf-bg-checkbox-focus: #ffffff;
  --vf-bg-checkbox-danger: #ffffff;
  --vf-bg-checkbox-success: #ffffff;
  --vf-bg-disabled: var(--vf-gray-200);
  --vf-bg-selected: #1118270d;
  --vf-bg-passive: var(--vf-gray-300);
  --vf-bg-icon: var(--vf-gray-500);
  --vf-bg-danger: var(--vf-danger-lighter);
  --vf-bg-success: var(--vf-success-lighter);
  --vf-bg-tag: var(--vf-primary);
  --vf-bg-slider-handle: var(--vf-primary);
  --vf-bg-toggle-handle: #ffffff;
  --vf-bg-date-head: var(--vf-gray-100);
  --vf-bg-addon: #ffffff00;
  --vf-bg-btn: var(--vf-primary);
  --vf-bg-btn-danger: var(--vf-danger);
  --vf-bg-btn-secondary: var(--vf-gray-200);
  --vf-bg-table-header: var(--vf-gray-100);
  --vf-color-input: var(--vf-gray-800);
  --vf-color-input-hover: var(--vf-gray-800);
  --vf-color-input-focus: var(--vf-gray-800);
  --vf-color-input-danger: var(--vf-gray-800);
  --vf-color-input-success: var(--vf-gray-800);
  --vf-color-disabled: var(--vf-gray-400);
  --vf-color-placeholder: var(--vf-gray-300);
  --vf-color-passive: var(--vf-gray-700);
  --vf-color-muted: var(--vf-gray-500);
  --vf-color-floating: var(--vf-gray-500);
  --vf-color-floating-focus: var(--vf-gray-500);
  --vf-color-floating-success: var(--vf-gray-500);
  --vf-color-floating-danger: var(--vf-gray-500);
  --vf-color-danger: var(--vf-danger);
  --vf-color-success: var(--vf-success);
  --vf-color-tag: var(--vf-color-on-primary);
  --vf-color-addon: var(--vf-gray-800);
  --vf-color-date-head: var(--vf-gray-700);
  --vf-color-btn: var(--vf-color-on-primary);
  --vf-color-btn-danger: #ffffff;
  --vf-color-btn-secondary: var(--vf-gray-700);
  --vf-color-table-header: var(--vf-gray-800);
  --vf-border-color-input: var(--vf-gray-300);
  --vf-border-color-input-hover: var(--vf-gray-300);
  --vf-border-color-input-focus: var(--vf-primary);
  --vf-border-color-input-danger: var(--vf-gray-300);
  --vf-border-color-input-success: var(--vf-gray-300);
  --vf-border-color-checkbox: var(--vf-gray-300);
  --vf-border-color-checkbox-focus: var(--vf-primary);
  --vf-border-color-checkbox-hover: var(--vf-gray-300);
  --vf-border-color-checkbox-danger: var(--vf-gray-300);
  --vf-border-color-checkbox-success: var(--vf-gray-300);
  --vf-border-color-checked: var(--vf-primary);
  --vf-border-color-passive: var(--vf-gray-300);
  --vf-border-color-slider-tooltip: var(--vf-primary);
  --vf-border-color-tag: var(--vf-primary);
  --vf-border-color-btn: var(--vf-primary);
  --vf-border-color-btn-danger: var(--vf-danger);
  --vf-border-color-btn-secondary: var(--vf-gray-200);
  --vf-border-color-blockquote: var(--vf-gray-300);
  --vf-border-color-hr: var(--vf-gray-300);
  --vf-border-color-signature-hr: var(--vf-gray-300);
  --vf-border-color-table: var(--vf-gray-300);
  --vf-border-width-input-t: 1px;
  --vf-border-width-input-r: 1px;
  --vf-border-width-input-b: 1px;
  --vf-border-width-input-l: 1px;
  --vf-border-width-radio-t: 1px;
  --vf-border-width-radio-r: 1px;
  --vf-border-width-radio-b: 1px;
  --vf-border-width-radio-l: 1px;
  --vf-border-width-checkbox-t: 1px;
  --vf-border-width-checkbox-r: 1px;
  --vf-border-width-checkbox-b: 1px;
  --vf-border-width-checkbox-l: 1px;
  --vf-border-width-dropdown: 1px;
  --vf-border-width-btn: 1px;
  --vf-border-width-toggle: 0.125rem;
  --vf-border-width-tag: 1px;
  --vf-border-width-blockquote: 3px;
  --vf-border-width-table: 1px;
  --vf-shadow-input: 0px 0px 0px 0px rgba(0, 0, 0, 0);
  --vf-shadow-input-hover: 0px 0px 0px 0px rgba(0, 0, 0, 0);
  --vf-shadow-input-focus: 0px 0px 0px 0px rgba(0, 0, 0, 0);
  --vf-shadow-handles: 0px 0px 0px 0px rgba(0, 0, 0, 0);
  --vf-shadow-handles-hover: 0px 0px 0px 0px rgba(0, 0, 0, 0);
  --vf-shadow-handles-focus: 0px 0px 0px 0px rgba(0, 0, 0, 0);
  --vf-shadow-btn: 0px 0px 0px 0px rgba(0, 0, 0, 0);
  --vf-shadow-dropdown: 0px 0px 0px 0px rgba(0, 0, 0, 0);
  --vf-radius-input: 0.25rem;
  --vf-radius-input-sm: 0.25rem;
  --vf-radius-input-lg: 0.25rem;
  --vf-radius-btn: 0.25rem;
  --vf-radius-btn-sm: 0.25rem;
  --vf-radius-btn-lg: 0.25rem;
  --vf-radius-small: 0.25rem;
  --vf-radius-small-sm: 0.25rem;
  --vf-radius-small-lg: 0.25rem;
  --vf-radius-large: 0.25rem;
  --vf-radius-large-sm: 0.25rem;
  --vf-radius-large-lg: 0.25rem;
  --vf-radius-tag: 0.25rem;
  --vf-radius-tag-sm: 0.25rem;
  --vf-radius-tag-lg: 0.25rem;
  --vf-radius-checkbox: 0.25rem;
  --vf-radius-checkbox-sm: 0.25rem;
  --vf-radius-checkbox-lg: 0.25rem;
  --vf-radius-slider: 0.25rem;
  --vf-radius-slider-sm: 0.25rem;
  --vf-radius-slider-lg: 0.25rem;
  --vf-radius-image: 0.25rem;
  --vf-radius-image-sm: 0.25rem;
  --vf-radius-image-lg: 0.25rem;
  --vf-radius-gallery: 0.25rem;
  --vf-radius-gallery-sm: 0.25rem;
  --vf-radius-gallery-lg: 0.25rem;
  --vf-checkbox-size: 1rem;
  --vf-checkbox-size-sm: 0.875rem;
  --vf-checkbox-size-lg: 1rem;
  --vf-gallery-size: 6rem;
  --vf-gallery-size-sm: 5rem;
  --vf-gallery-size-lg: 7rem;
  --vf-toggle-width: 3rem;
  --vf-toggle-width-sm: 2.75rem;
  --vf-toggle-width-lg: 3rem;
  --vf-toggle-height: 1.25rem;
  --vf-toggle-height-sm: 1rem;
  --vf-toggle-height-lg: 1.25rem;
  --vf-slider-height: 0.375rem;
  --vf-slider-height-sm: 0.3125rem;
  --vf-slider-height-lg: 0.5rem;
  --vf-slider-height-vertical: 20rem;
  --vf-slider-height-vertical-sm: 20rem;
  --vf-slider-height-vertical-lg: 20rem;
  --vf-slider-handle-size: 1rem;
  --vf-slider-handle-size-sm: 0.875rem;
  --vf-slider-handle-size-lg: 1.25rem;
  --vf-slider-tooltip-distance: 0.5rem;
  --vf-slider-tooltip-distance-sm: 0.375rem;
  --vf-slider-tooltip-distance-lg: 0.5rem;
  --vf-slider-tooltip-arrow-size: 0.3125rem;
  --vf-slider-tooltip-arrow-size-sm: 0.3125rem;
  --vf-slider-tooltip-arrow-size-lg: 0.3125rem;

  .group-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 10px;
    background-color: #f0f0f0;
    border-radius: 5px;
    max-width: 100%;
  }

  .toggle-icon {
    cursor: pointer;

    margin-left: -50px;
    transition: transform 0.3s ease;
  }

  .toggle-icon.is-open {
    transform: rotate(180deg);
  }

  /* fade transitions removed for performance */

  /* Removed will-change for better performance */

  .border-group {
    border: 1px solid #e5e5e5 !important;
    padding: 1rem !important;
  }

  .toggle-icon-container {
    cursor: pointer;
    margin-left: -65px;
    transform: scale(0.8);
    margin-top: -3px;
  }

  .toggle-icon-container-tongtrang {
    margin-left: -160px;
    cursor: pointer;
    transform: scale(0.8);
    margin-top: -3px;
  }

  .toggle-icon-container-tiensubenh {
    margin-left: -160px;
    cursor: pointer;
    transform: scale(0.8);
    margin-top: -3px;
  }

  .toggle-icon-container-tiensubenhxahoi {
    margin-left: -90px;
    cursor: pointer;
    transform: scale(0.8);
    margin-top: -3px;
  }

  .toggle-icon-container-tinhthan {
    margin-left: -180px;
    cursor: pointer;
    transform: scale(0.8);
    margin-top: -3px;
  }

  .toggle-icon-container-vandong {
    margin-left: -180px;
    cursor: pointer;
    transform: scale(0.8);
    margin-top: -3px;
  }

  .toggle-icon-container-dinhduong {
    margin-left: -180px;
    cursor: pointer;
    transform: scale(0.8);
    margin-top: -3px;
  }

  .toggle-icon-container-duonghuyet {
    margin-left: -50px;
    cursor: pointer;
    transform: scale(0.8);
    margin-top: -3px;
  }

  .toggle-icon-container-chamsocbanchan {
    margin-left: -50px;
    cursor: pointer;
    transform: scale(0.8);
    margin-top: -3px;
  }

  .toggle-icon-container-sudungthuoc {
    margin-left: -50px;
    cursor: pointer;
    transform: scale(0.8);
    margin-top: -3px;
  }

  .toggle-icon-container-hoctap {
    margin-left: -50px;
    cursor: pointer;
    transform: scale(0.8);
    margin-top: -3px;
  }

  .toggle-icon-container-muctieu {
    margin-left: -50px;
    cursor: pointer;
    transform: scale(0.8);
    margin-top: -3px;
  }

  .labeltext {
    font-weight: 600;
    color: #000;
  }
}
</style>
